import moment from "moment";
import { Calendar, Download } from "../../../assets/icons";
import { LABELS } from "../../labels/catalog.labels";

export const DrCables = [
    {
        title: `${LABELS?.cable}`,
        dataIndex: "name",
        key: "name",
        width: "15.25%",
        sortable: true,
        minwidth: "12rem",
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "equipmentStatus",
        width: "6.26%",
        sortable: true,
    },
    {
        title: `Display order`,
        dataIndex: "display_Order",
        key: "display_Order",
        width: "2.2%",
        sortable: true,
    },
    {
       title: `Awg Id`,
        dataIndex: "awG_id",
        key: "awG_id",
        width: "2.2%",
        sortable: true, 
    },
    {
        title: `Dimension A`,
        dataIndex: "dimensionA",
        key: "dimensionA",
        width: "6.25%",
        sortable: true,
    },
    {
        title: `Dimension B`,
        dataIndex: "dimensionB",
        key: "dimensionB",
        width: "6.25%",
        sortable: true,
    },
    {
        title: `V0`,
        dataIndex: "v0",
        key: "v0",
        width: "6%",
        sortable: true,
    },
    {
        title: `V1`,
        dataIndex: "v1",
        key: "v1",
        width: "6%",
        sortable: true,
    },
    {
        title: `V2`,
        dataIndex: "v2",
        key: "v2",
        width: "4.25%",
        sortable: true,
    },
    {
        title: `V3`,
        dataIndex: "v3",
        key: "v3",
        width: "4.25%",
        sortable: true,
    },
    {
        title: `V4`,
        dataIndex: "v4",
        key: "v4",
        width: "4.25%",
        sortable: true,
    },
    {
        title: `V5`,
        dataIndex: "v5",
        key: "v5",
        width: "4.25%",
        sortable: true,
    },
    {
        title: `Profile`,
        dataIndex: "profile",
        key: "profile",
        width: "6.25%",
        sortable: true,
    },
    {
        title: `Temp rating F`,
        dataIndex: "tempRating_F",
        key: "tempRating_F",
        width: "6.25%",
        sortable: true,
    },
    {
        title: `Temp rating C`,
        dataIndex: "tempRating_C",
        key: "tempRating_C",
        width: "6.25%",
        sortable: true,
    },
    {
        title: `Temp correction factor`,
        dataIndex: "tempCorrectionFactor",
        key: "tempCorrectionFactor",
        width: "6.25%",
        sortable: true,
    },
    {
        title: `Permian`,
        dataIndex: "permian",
        key: "permian",
        width: "6.25%",
        sortable: true,
    },
    {
        title: `International`,
        dataIndex: "international",
        key: "international",
        width: "6.25%",
        sortable: true,
    },
];

export const DrGasHandlers = [
    {
        title: `Gas handler`,
        dataIndex: "pumpName",
        key: "pumpName",
        width: "9%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "equipmentStatus",
        width: "3%",
        sortable: true,
    },
    {
        title: `No of stages`,
        dataIndex: "noOfStages",
        key: 'noOfStages',
        width: "3%",
        sortable: true,
    },
    {
        title: `HP`,
        dataIndex: "hp",
        key: 'hp',
        width: "3%",
        sortable: true,
    },
    {
        title: `BEP flow`,
        dataIndex: "bepFLow",
        key: "bepFlow",
        width: "3%",
        sortable: true,
    },
    {
        title: `Min flow`,
        dataIndex: "minFlow",
        key: "minFlow",
        width: "3%",
        sortable: true,
    },
    {
        title: `Max flow`,
        dataIndex: "maxFlow",
        key: "maxFlow",
        width: "3%",
        sortable: true,
    },
    {
        title: `Min viscosity`,
        dataIndex: "minViscosity",
        key: "minViscosity",
        width: "3%",
        sortable: true,
    },
    {
        title: `Max viscosity`,
        dataIndex: "maxViscosity",
        key: "maxViscosity",
        width: "3%",
        sortable: true,
    },
    {
        title: `Shaft OD`,
        dataIndex: "shaftOD",
        key: "shaftOD",
        width: "3%",
        sortable: true,
    },
    {
        title: `Std shaft`,
        dataIndex: "stdShaft",
        key: "stdShaft",
        width: "3%",
        sortable: true,
    },
    {
        title: `Hs Shaft`,
        dataIndex: "hsShaft",
        key: "hsShaft",
        width: "3%",
        sortable: true,
    },
    {
        title: `B0`,
        dataIndex: "b0",
        key: "b0",
        width: "3%",
        sortable: true,
    },
    {
        title: `B1`,
        dataIndex: "b1",
        key: "b1",
        width: "3%",
        sortable: true,
    },
    {
        title: `B2`,
        dataIndex: "b2",
        key: "b2",
        width: "3%",
        sortable: true,
    },
    {
        title: `B3`,
        dataIndex: "b3",
        key: "b3",
        width: "3%",
        sortable: true,
    },
    {
        title: `B4`,
        dataIndex: "b4",
        key: "b4",
        width: "3%",
        sortable: true,
    },
    {
        title: `B5`,
        dataIndex: "b5",
        key: "b5",
        width: "3%",
        sortable: true,
    },
    {
        title: `H0`,
        dataIndex: "h0",
        key: "h0",
        width: "3%",
        sortable: true,
    },
    {
        title: `H1`,
        dataIndex: "h1",
        key: "h1",
        width: "3%",
        sortable: true,
    },
    {
        title: `H2`,
        dataIndex: "h2",
        key: "h2",
        width: "3%",
        sortable: true,
    },
    {
        title: `H3`,
        dataIndex: "h3",
        key: "h3",
        width: "3%",
        sortable: true,
    },
    {
        title: `H4`,
        dataIndex: "h4",
        key: "h4",
        width: "3%",
        sortable: true,
    },
    {
        title: `H5`,
        dataIndex: "h5",
        key: "h5",
        width: "3%",
        sortable: true,
    },
    {
        title: `VH1`,
        dataIndex: "vH1",
        key: "vH1",
        width: "3%",
        sortable: true,
    },
    {
        title: `VH2`,
        dataIndex: "vH2",
        key: "vH2",
        width: "3%",
        sortable: true,
    },
    {
        title: `VH3`,
        dataIndex: "vH3",
        key: "vH3",
        width: "3%",
        sortable: true,
    },
    {
        title: `VH4`,
        dataIndex: "vH4",
        key: "vH4",
        width: "3%",
        sortable: true,
    },
    {
        title: `VP1`,
        dataIndex: "vP1",
        key: "vP1",
        width: "3%",
        sortable: true,
    },
    {
        title: `VP2`,
        dataIndex: "vP2",
        key: "vP2",
        width: "3%",
        sortable: true,
    },
    {
        title: `VP3`,
        dataIndex: "vP3",
        key: "vP3",
        width: "3%",
        sortable: true,
    },
    {
        title: `VP4`,
        dataIndex: "vP4",
        key: "vP4",
        width: "3%",
        sortable: true,
    },
    {
        title: `VQ1`,
        dataIndex: "vQ1",
        key: "vQ1",
        width: "3%",
        sortable: true,
    },
    {
        title: `VQ2`,
        dataIndex: "vQ2",
        key: "vQ2",
        width: "3%",
        sortable: true,
    },
    {
        title: `VQ3`,
        dataIndex: "vQ3",
        key: "vQ3",
        width: "3%",
        sortable: true,
    },
    {
        title: `VQ4`,
        dataIndex: "vQ4",
        key: "vQ4",
        width: "3%",
        sortable: true,
    },
    {
        title: `Permian`,
        dataIndex: "permian",
        key: "permian",
        width: "3%",
        sortable: true,
    },
    {
        title: `International`,
        dataIndex: "international",
        key: "international",
        width: "3%",
        sortable: true,
    },
];

export const DrGasSeparators = [
    {
        title: `Gas separator`,
        dataIndex: "name",
        key: "name",
        width: "17.5%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "equipmentStatus",
        width: "7.5%",
        sortable: true,
    },
    {
        title: `Series`,
        dataIndex: "series",
        key: "series",
        width: "7.5%",
        sortable: true,
    },
    {
        title: "Series type",
        dataIndex: "seriesType",
        key: "seriesType",
        width: "7.5%",
        sortable: true
    },
    {
        title: `Power`,
        dataIndex: "hp",
        key: "hp",
        width: "7.5%",
        sortable: true,
    },
    {
        title: `Std shaft HP`,
        dataIndex: "stdShaftHP",
        key: "stdShaftHP",
        width: "7.5%",
        sortable: true,
    },
    {
        title: `Hs shaft HP`,
        dataIndex: "hsShaftHP",
        key: "hsShaftHP",
        width: "7.5%",
        sortable: true,
    },
    {
        title: `Max flow`,
        dataIndex: "maxFlow",
        key: "maxFlow",
        width: "7.5%",
        sortable: true,
    },
    {
        title: `Max outer diameter (In)`,
        dataIndex: "maxOuterDiaIn",
        key: "maxOuterDiaIn",
        width: "7.5%",
        sortable: true,
    },
    {
        title: `Max outer diameter (MM)`,
        dataIndex: "maxOuterDiaMM",
        key: "maxOuterDiaMM",
        width: "7.5%",
        sortable: true,
    },
    {
        title: `Permian`,
        dataIndex: "permian",
        key: "permian",
        width: "7.5%",
        sortable: true,
    },
    {
        title: `International`,
        dataIndex: "international",
        key: "international",
        width: "7.5%",
        sortable: true,
    },
];

export const DrMotorLeads = [
    {
        title: `Motor lead`,
        dataIndex: "name",
        key: "name",
        width: "19%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "equipmentStatus",
        width: "13.5%",
        sortable: true,
    },
    {
        title: `Series`,
        dataIndex: "motorSeries",
        key: "motorSeries",
        width: "13.5%",
        sortable: true,
    },
    {
        title: `Dimension A`,
        dataIndex: "dimensionA",
        key: "dimensionA",
        width: "13.5%",
        sortable: true,
    },
    {
        title: `Dimension B`,
        dataIndex: "dimensionB",
        key: "dimensionB",
        width: "13.5%",
        sortable: true,
    },
    {
        title: `Permian`,
        dataIndex: "permian",
        key: "permian",
        width: "13.5%",
        sortable: true,
    },
    {
        title: `International`,
        dataIndex: "international",
        key: "international",
        width: "13.5%",
        sortable: true,
    },
];

export const DrMotorSensors = [
    {
        title: `Motor sensor`,
        dataIndex: "name",
        key: "name",
        width: "20%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "equipmentStatus",
        width: "10%",
        sortable: true,
    },
    {
        title: `Series`,
        dataIndex: "series",
        key: "series",
        width: "10%",
        sortable: true,
    },
    {
        title: `Pn`,
        dataIndex: "pn",
        key: "pn",
        width: "10%",
        sortable: true,
    },
    {
        title: `Length`,
        dataIndex: "length",
        key: "length",
        width: "10%",
        sortable: true,
    },
    {
        title: `Weight`,
        dataIndex: "weight",
        key: "weight",
        width: "10%",
        sortable: true,
    },
    {
        title: `Diameter`,
        dataIndex: "diameter",
        key: "diameter",
        width: "10%",
        sortable: true,
    },
    {
        title: `Permian`,
        dataIndex: "permian",
        key: "permian",
        width: "10%",
        sortable: true,
    },
    {
        title: `International`,
        dataIndex: "international",
        key: "international",
        width: "10%",
        sortable: true,
    },
];

export const DrMotors = [
    {
        title: `Motor`,
        dataIndex: "name",
        key: "name",
        width: "12%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "equipmentStatus",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `No of motors`,
        dataIndex: "noOfMotors",
        key: "noOfMotors",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `Series`,
        dataIndex: "series",
        key: "series",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `Series type`,
        dataIndex: "seriesType",
        key: "seriesType",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `Display order`,
        dataIndex: "display_Order",
        key: "display_Order",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `Size`,
        dataIndex: "size",
        key: "size",
        width: "5%",
        sortable: true,
    },
    {
        title: `Current`,
        dataIndex: "current",
        key: "current",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `Voltage`,
        dataIndex: "voltage",
        key: "voltage",
        width: "2.2%",
        sortable: true,
    },
    {
        title: "Base HP",
        dataIndex: "baseHP",
        key: "baseHP",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `KW`,
        dataIndex: "kw",
        key: "kw",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `Motor OD`,
        dataIndex: "motorOD",
        key: "motorOD",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `Min casing size`,
        dataIndex: "minCasingSize",
        key: "minCasingSize",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `Max opearting temp`,
        dataIndex: "maxOperatingTemp",
        key: "maxOperatingTemp",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `Max bottom hole temp`,
        dataIndex: "maxBottomHoleTemp",
        key: "maxBottomHoleTemp",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `C0`,
        dataIndex: "c0",
        key: "c0",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `C1`,
        dataIndex: "c1",
        key: "c1",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `C2`,
        dataIndex: "c2",
        key: "c2",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `C3`,
        dataIndex: "c3",
        key: "c3",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `C4`,
        dataIndex: "c4",
        key: "c4",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `C5`,
        dataIndex: "c5",
        key: "c5",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `E0`,
        dataIndex: "e0",
        key: "e0",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `E1`,
        dataIndex: "e1",
        key: "e1",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `E2`,
        dataIndex: "e2",
        key: "e2",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `E3`,
        dataIndex: "e3",
        key: "e3",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `E4`,
        dataIndex: "e4",
        key: "e4",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `E5`,
        dataIndex: "e5",
        key: "e5",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `H0`,
        dataIndex: "h0",
        key: "h0",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `H1`,
        dataIndex: "h1",
        key: "h1",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `H2`,
        dataIndex: "h2",
        key: "h2",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `H3`,
        dataIndex: "h3",
        key: "h3",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `H4`,
        dataIndex: "h4",
        key: "h4",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `H5`,
        dataIndex: "h5",
        key: "h5",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `P0`,
        dataIndex: "p0",
        key: "p0",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `P1`,
        dataIndex: "p1",
        key: "p1",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `P2`,
        dataIndex: "p2",
        key: "p2",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `P3`,
        dataIndex: "p3",
        key: "p3",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `P4`,
        dataIndex: "p4",
        key: "p4",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `P5`,
        dataIndex: "p5",
        key: "p5",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `S0`,
        dataIndex: "s0",
        key: "s0",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `S1`,
        dataIndex: "s1",
        key: "s1",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `S2`,
        dataIndex: "s2",
        key: "s2",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `S3`,
        dataIndex: "s3",
        key: "s3",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `S4`,
        dataIndex: "s4",
        key: "s4",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `S5`,
        dataIndex: "s5",
        key: "s5",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `V0`,
        dataIndex: "v0",
        key: "v0",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `V1`,
        dataIndex: "v1",
        key: "v1",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `V2`,
        dataIndex: "v2",
        key: "v2",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `V3`,
        dataIndex: "v3",
        key: "v3",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `V4`,
        dataIndex: "v4",
        key: "v4",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `V5`,
        dataIndex: "v5",
        key: "v5",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `Permian`,
        dataIndex: "permian",
        key: "permian",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `International`,
        dataIndex: "international",
        key: "international",
        width: "2.2%",
        sortable: true,
    },
];

export const DrProtectors = [
    {
        title: `Protector`,
        dataIndex: "name",
        key: "name",
        width: "12%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "equipmentStatus",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Series`,
        dataIndex: "series",
        key: "series",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Display order`,
        dataIndex: "display_Order",
        key: "display_Order",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `OD`,
        dataIndex: "od",
        key: "od",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Model`,
        dataIndex: "model",
        key: "model",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Temp rating`,
        dataIndex: "tempRating",
        key: "tempRating",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Power`,
        dataIndex: "hp",
        key: "hp",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Std shaft HP`,
        dataIndex: "stdShaftHP",
        key: "stdShaftHP",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Hs shaft HP`,
        dataIndex: "hsShaftHP",
        key: "hsShaftHP",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Std bearing max load`,
        dataIndex: "stdBearingMaxLoad",
        key: "stdBearingMaxLoad",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Hs bearing max load`,
        dataIndex: "hsBearingMaxLoad",
        key: "hsBearingMaxLoad",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Max outer diameter (In)`,
        dataIndex: "maxOuterDiaIn",
        key: "maxOuterDiaIn",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Max outer diameter (mm)`,
        dataIndex: "maxOuterDiaMM",
        key: "maxOuterDiaMM",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Volume 1`,
        dataIndex: "chamber1Vol",
        key: "chamber1Vol",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Volume 2`,
        dataIndex: "chamber2Vol",
        key: "chamber2Vol",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Volume 3`,
        dataIndex: "chamber3Vol",
        key: "chamber3Vol",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Volume 4`,
        dataIndex: "chamber3Vol",
        key: "chamber4Vol",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Permian`,
        dataIndex: "permian",
        key: "permian",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `International`,
        dataIndex: "international",
        key: "international",
        width: "5.5%",
        sortable: true,
    },
];

export const DrPumps = [
    {
        title: `Pump`,
        dataIndex: "pump",
        key: "pump",
        width: "16%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "equipmentStatus",
        width: "8%",
        sortable: true,
    },
    {
        title: `Series`,
        dataIndex: "series",
        key: "series",
        width: "8%",
        sortable: true,
    },
    {
        title: `Display order`,
        dataIndex: "display_Order",
        key: "display_Order",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `OD`,
        dataIndex: "od",
        key: "od",
        width: "8%",
        sortable: true,
    },
    {
        title: `Min casing size`,
        dataIndex: "minCasingSize",
        key: "minCasingSize",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Nominal casing size`,
        dataIndex: "nominalCasingSize",
        key: "nominalCasingSize",
        width: "8%",
        sortable: true,
    },
    {
        title: `Housing type`,
        dataIndex: "housingType",
        key: "housingType",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Shaft`,
        dataIndex: "shaft",
        key: "shaft",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `BEP flow`,
        dataIndex: "bepFlow",
        key: "bepFlow",
        width: "8%",
        sortable: true,
    },
    {
        title: `Comp thrust`,
        dataIndex: "compThrust",
        key: "compThrust",
        width: "8%",
        sortable: true,
    },
    {
        title: `Legacy`,
        dataIndex: "legacy",
        key: "legacy",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `Operating BPD range`,
        dataIndex: "operatingBPDRange",
        key: "operatingBPDRange",
        width: "8%",
        sortable: true,
    },
    {
        title: `Std shaft`,
        dataIndex: "stdShaft",
        key: "stdShaft",
        width: "",
        sortable: true,
    },
    {
        title: `Hs Shaft`,
        dataIndex: "hsShaft",
        key: "hsShaft",
        width: "",
        sortable: true,
    },
    {
        title: `Std housing`,
        dataIndex: "stdHousing",
        key: "stdHousing",
        width: "",
        sortable: true,
    },
    {
        title: `Hs housing`,
        dataIndex: "hsHousing",
        key: "hsHousing",
        width: "",
        sortable: true,
    },
    {
        title: `Impeller flow`,
        dataIndex: "impellerFlow",
        key: "impellerFlow",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `Min operating BPD`,
        dataIndex: "minOperatingBPD",
        key: "minOperatingBPD",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `Max operating BPD`,
        dataIndex: "maxOperatingBPD",
        key: "maxOperatingBPD",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `Max plotted production`,
        dataIndex: "maxPlottedProduction",
        key: "maxPlottedProduction",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Shaft Dia (mm)`,
        dataIndex: "shaftDiaMM",
        key: "shaftDiaMM",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `Plot x space`,
        dataIndex: "plot_x_Space",
        key: "plot_x_Space",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `Plot x space metric`,
        dataIndex: "plot_x_Space_Metric",
        key: "plot_x_Space_Metric",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `Plot eff intervals`,
        dataIndex: "plot_Eff_Intervals",
        key: "plot_Eff_Intervals",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `Shaft area`,
        dataIndex: "shaftArea",
        key: "shaftArea",
        width: "",
        sortable: true,
    },
    {
        title: `Min viscosity`,
        dataIndex: "minViscosity",
        key: "minViscosity",
        width: "",
        sortable: true,
    },
    {
        title: `Max viscosity`,
        dataIndex: "maxViscosity",
        key: "maxViscosity",
        width: "",
        sortable: true,
    },
    {
        title: "BEP lift per stage",
        dataIndex: "bepLiftPerStage",
        key: "bepLiftPerStage",
        width: "5.5%",
        sortable: true,
    },
    {
        title: "BEP power per stage",
        dataIndex: "bepPowerPerStage",
        key: "bepPowerPerStage",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `B0`,
        dataIndex: "b0",
        key: "b0",
        width: "5%",
        sortable: true,
    },
    {
        title: `B1`,
        dataIndex: "b1",
        key: "b1",
        width: "5%",
        sortable: true,
    },
    {
        title: `B2`,
        dataIndex: "b2",
        key: "b2",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `B3`,
        dataIndex: "b3",
        key: "b3",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `B4`,
        dataIndex: "b4",
        key: "b4",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `B5`,
        dataIndex: "b5",
        key: "b5",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `H0`,
        dataIndex: "h0",
        key: "h0",
        width: "5%",
        sortable: true,
    },
    {
        title: `H1`,
        dataIndex: "h1",
        key: "h1",
        width: "5%",
        sortable: true,
    },
    {
        title: `H2`,
        dataIndex: "h2",
        key: "h2",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `H3`,
        dataIndex: "h3",
        key: "h3",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `H4`,
        dataIndex: "h4",
        key: "h4",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `H5`,
        dataIndex: "h5",
        key: "h5",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `VH1`,
        dataIndex: "vH1",
        key: "vH1",
        width: "5%",
        sortable: true,
    },
    {
        title: `VH2`,
        dataIndex: "vH2",
        key: "vH2",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `VH3`,
        dataIndex: "vH3",
        key: "vH3",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `VH4`,
        dataIndex: "vH4",
        key: "vH4",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `VP1`,
        dataIndex: "vP1",
        key: "vP1",
        width: "5%",
        sortable: true,
    },
    {
        title: `VP2`,
        dataIndex: "vP2",
        key: "vP2",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `VP3`,
        dataIndex: "vP3",
        key: "vP3",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `VP4`,
        dataIndex: "vP4",
        key: "vP4",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `VQ1`,
        dataIndex: "vQ1",
        key: "vQ1",
        width: "5%",
        sortable: true,
    },
    {
        title: `VQ2`,
        dataIndex: "vQ2",
        key: "vQ2",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `VQ3`,
        dataIndex: "vQ3",
        key: "vQ3",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `VQ4`,
        dataIndex: "vQ4",
        key: "vQ4",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `Permian`,
        dataIndex: "permian",
        key: "permian",
        width: "5%",
        sortable: true,
    },
    {
        title: `International`,
        dataIndex: "international",
        key: "international",
        width: "5%",
        sortable: true,
    },
];

export const DrSwitchBoard = [
    {
        title: `Switch board`,
        dataIndex: "description",
        key: "description",
        width: "14.8%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "equipmentStatus",
        width: "14.2%",
        sortable: true,
    },
    {
        title: `Voltage`,
        dataIndex: "voltage",
        key: "voltage",
        width: "14.2%",
        sortable: true,
    },
    {
        title: "Control",
        dataIndex: "control",
        key: "control",
        width: "14.2%",
        sortable: true
    },
    {
        title: `Permian`,
        dataIndex: "permian",
        key: "permian",
        width: "14.2%",
        sortable: true,
    },
    {
        title: `International`,
        dataIndex: "international",
        key: "international",
        width: "14.2%",
        sortable: true,
    },
];

export const DrVSD = [
    {
        title: `VSD`,
        dataIndex: "description",
        key: "description",
        width: "12%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "equipmentStatus",
        width: "8%",
        sortable: true,
    },
    {
        title: `Voltage`,
        dataIndex: "voltage",
        key: "voltage",
        width: "8%",
        sortable: true,
    },
    {
        title: "Power",
        dataIndex: "power",
        key: "power",
        width: "8%",
        sortable: true
    },
    {
        title: `Current in`,
        dataIndex: "current_In",
        key: "current_In",
        width: "8%",
        sortable: true,
    },
    {
        title: `Current out`,
        dataIndex: "current_Out",
        key: "current_Out",
        width: "8%",
        sortable: true,
    },
    {
        title: `Weight lb`,
        dataIndex: "weight_lb",
        key: "weight_lb",
        width: "8%",
        sortable: true,
    },
    {
        title: `Weight kg`,
        dataIndex: "weight_Kg",
        key: "weight_Kg",
        width: "8%",
        sortable: true,
    },
    {
        title: `Make`,
        dataIndex: "make",
        key: "make",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `phase`,
        dataIndex: "phase",
        key: "phase",
        width: "8%",
        sortable: true,
    },
    {
        title: `pulse`,
        dataIndex: "pulse",
        key: "pulse",
        width: "5%",
        sortable: true,
    },
    {
        title: `enclosure`,
        dataIndex: "enclosure",
        key: "enclosure",
        width: "5%",
        sortable: true,
    },
    {
        title: `Permian`,
        dataIndex: "permian",
        key: "permian",
        width: "5%",
        sortable: true,
    },
    {
        title: `International`,
        dataIndex: "international",
        key: "international",
        width: "5%",
        sortable: true,
    },
];

export const SrAccAboveESP = [
    {
        title: `ACC above ESP`,
        dataIndex: "accAboveESP",
        key: "accAboveESP",
        width: "20%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "equipmentStatus",
        width: "10%",
        sortable: true,
    },
    {
        title: `PN`,
        dataIndex: "pn",
        key: "pn",
        width: "10%",
        sortable: true,
    },
    {
        title: `Length`,
        dataIndex: "length",
        key: "length",
        width: "10%",
        sortable: true,
    },
    {
        title: `Weight`,
        dataIndex: "weight",
        key: "weight",
        width: "10%",
        sortable: true,
    },
    {
        title: `Diameter`,
        dataIndex: "diameter",
        key: "diameter",
        width: "10%",
        sortable: true,
    },
    {
        title: `Masked diameter`,
        dataIndex: "masked_Diam",
        key: "masked_Diam",
        width: "10%",
        sortable: true,
    }
];

export const SrAccBelowESP = [
    {
        title: `ACC below ESP`,
        dataIndex: "accBelowESP",
        key: "accBelowESP",
        width: "20%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "equipmentStatus",
        width: "10%",
        sortable: true,
    },
    {
        title: `PN`,
        dataIndex: "pn",
        key: "pn",
        width: "10%",
        sortable: true,
    },
    {
        title: `Length`,
        dataIndex: "length",
        key: "length",
        width: "10%",
        sortable: true,
    },
    {
        title: `Weight`,
        dataIndex: "weight",
        key: "weight",
        width: "10%",
        sortable: true,
    },
    {
        title: `Diameter`,
        dataIndex: "diameter",
        key: "diameter",
        width: "10%",
        sortable: true,
    },
    {
        title: `Casing diameter`,
        dataIndex: "casing_Diam__In",
        key: "casing_Diam__In",
        width: "10%",
        sortable: true,
    },
];

export const SrBOH = [
    {
        title: `BOH`,
        dataIndex: "boh",
        key: "boh",
        width: "14%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "equipmentStatus",
        width: "9%",
        sortable: true,
    },
    {
        title: `PN`,
        dataIndex: "boH_PN",
        key: "boH_PN",
        width: "9%",
        sortable: true,
    },
    {
        title: `Length`,
        dataIndex: "length",
        key: "length",
        width: "9%",
        sortable: true,
    },
    {
        title: `Weight`,
        dataIndex: "weight",
        key: "weight",
        width: "9%",
        sortable: true,
    },
    {
        title: `Series`,
        dataIndex: "series",
        key: "series",
        width: "9%",
        sortable: true,
    },
    {
        title: `OD`,
        dataIndex: "od",
        key: "od",
        width: "9%",
        sortable: true,
    },
    {
        title: `TubingOD`,
        dataIndex: "tubingOD",
        key: "tubingOD",
        width: "9%",
        sortable: true,
    },
    {
        title: `Tubing`,
        dataIndex: "tubing",
        key: "tubing",
        width: "9%",
        sortable: true,
    },
];

export const SrCables = [
    {
        title: `Cable`,
        dataIndex: "pN_Description",
        key: "pN_Description",
        width: "8.8%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "equipmentStatus",
        width: "7.6%",
        sortable: true,
    },
    {
        title: `PN`,
        dataIndex: "pn",
        key: "pn",
        width: "7.6%",
        sortable: true,
    },
    {
        title: `Weight`,
        dataIndex: "nominalWeight",
        key: "nominalWeight",
        width: "7.6%",
        sortable: true,
    },
    {
        title: `Material`,
        dataIndex: "armorMaterial",
        key: "armorMaterial",
        width: "7.6%",
        sortable: true,
    },
    {
        title: `Dimension`,
        dataIndex: "dimensions_in_",
        key: "dimensions_in_",
        width: "7.6%",
        sortable: true,
    },
    {
        title: `Insulation`,
        dataIndex: "insulation",
        key: "insulation",
        width: "7.6%",
        sortable: true,
    },
    {
        title: `Temp rating`,
        dataIndex: "tempRating__C_",
        key: "tempRating__C_",
        width: "7.6%",
        sortable: true,
    },
    {
        title: `Voltage rating`,
        dataIndex: "voltRating_KV_",
        key: "voltRating_KV_",
        width: "7.6%",
        sortable: true,
    },
    {
       title: `Awg Id`,
        dataIndex: "awG_id",
        key: "awG_id",
        width: "5.5%",
        sortable: true, 
    },
    {
        title: `Barrier`,
        dataIndex: "barrier",
        key: "barrier",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Profile`,
        dataIndex: "profile",
        key: "profile",
        width: "7.6%",
        sortable: true,
    },
    {
        title: `standardization`,
        dataIndex: "standardization",
        key: "standardization",
        width: "7.6%",
        sortable: true,
    }
];

export const SrGasHandlers = [
    {
        title: `Gas handler`,
        dataIndex: "pumpName",
        key: "pumpName",
        width: "9%",
        sortable: true,
    },
    {
        title: `Equipment name`,
        dataIndex: "gas_Handling",
        key: "gas_Handling",
        width: "10%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "equipmentStatus",
        width: "8%",
        sortable: true,
    },
    {
        title: `No of stages`,
        dataIndex: "noStages",
        key: "noStages",
        width: "8%",
        sortable: true,
    },
    {
        title: `PN`,
        dataIndex: "pn",
        key: "pn",
        width: "8%",
        sortable: true,
    },
    {
        title: `Length`,
        dataIndex: "length",
        key: "length",
        width: "8%",
        sortable: true,
    },
    {
        title: `Weight`,
        dataIndex: "weight",
        key: "weight",
        width: "8%",
        sortable: true,
    },
    {
        title: `OD`,
        dataIndex: "od",
        key: "od",
        width: "8%",
        sortable: true,
    },
    {
        title: `Series`,
        dataIndex: "series",
        key: "series",
        width: "8%",
        sortable: true,
    },
    {
        title: `Shaft type`,
        dataIndex: "shaftType",
        key: "shaftType",
        width: "8%",
        sortable: true,
    },
    {
        title: `Standardization`,
        dataIndex: "standardization",
        key: "standardization",
        width: "8%",
        sortable: true,
    },
];

export const SrGasSeparators = [
    {
        title: `Gas separator`,
        dataIndex: "pN_Description",
        key: "pN_Description",
        width: "14%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "status",
        key: "status",
        width: "8%",
        sortable: true,
    },
    {
        title: `PN`,
        dataIndex: "pn",
        key: "pn",
        width: "8%",
        sortable: true,
    },
    {
        title: `Length`,
        dataIndex: "length",
        key: "length",
        width: "8%",
        sortable: true,
    },
    {
        title: `Weight`,
        dataIndex: "weight",
        key: "weight",
        width: "8%",
        sortable: true,
    },
    {
        title: `OD`,
        dataIndex: "od",
        key: "od",
        width: "8%",
        sortable: true,
    },
    {
        title: `Series`,
        dataIndex: "series",
        key: "series",
        width: "8%",
        sortable: true,
    },
    {
        title: `Series type`,
        dataIndex: "seriesType",
        key: "seriesType",
        width: "8%",
        sortable: true,
    },
    {
        title: `Position`,
        dataIndex: "position",
        key: "position",
        width: "8%",
        sortable: true
    },
    {
        title: `Standardization`,
        dataIndex: "standardization",
        key: "standardization",
        width: "8%",
        sortable: true
    },
];

export const SrMLE = [
    {
        title: `MLE`,
        dataIndex: "mle",
        key: "mle",
        width: "15%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "equipmentStatus",
        width: "10%",
        sortable: true,
    },
    {
        title: `PN`,
        dataIndex: "mlE_PN",
        key: "mlE_PN",
        width: "12.5%",
        sortable: true,
    },
    {
        title: `Length`,
        dataIndex: "length",
        key: "length",
        width: "12.5%",
        sortable: true,
    },
    {
        title: `Weight`,
        dataIndex: "weight",
        key: "weight",
        width: "12.5%",
        sortable: true,
    },
    {
        title: `Series`,
        dataIndex: "series",
        key: "series",
        width: "12.5%",
        sortable: true,
    },
    {
        title: `Dimension`,
        dataIndex: "dim__TxW_",
        key: "dim__TxW_",
        width: "12.5%",
        sortable: true,
    },
    {
        title: `Wire gauge`,
        dataIndex: "wire_Gauge",
        key: "wire_Gauge",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Standardization`,
        dataIndex: "standardization",
        key: "standardization",
        width: "12.5%",
        sortable: true,
    },
];

export const SrMotors = [
    {
        title: `Motor`,
        dataIndex: "name",
        key: "name",
        width: "7%",
        sortable: true,
    },
    {
        title: `Equipment`,
        dataIndex: "pN_Description",
        key: "pN_Description",
        width: "9%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "status",
        key: "status",
        width: "7%",
        sortable: true,
    },
    {
        title: `PN`,
        dataIndex: "pn",
        key: "pn",
        width: "7%",
        sortable: true,
    },
    {
        title: `Length`,
        dataIndex: "length",
        key: "length",
        width: "7%",
        sortable: true,
    },
    {
        title: `Weight`,
        dataIndex: "weight",
        key: "weight",
        width: "7%",
        sortable: true,
    },
    {
        title: `Series`,
        dataIndex: "series",
        key: "series",
        width: "7%",
        sortable: true,
    },
    {
        title: `OD`,
        dataIndex: "od",
        key: "od",
        width: "7%",
        sortable: true,
    },
    {
        title: `Current`,
        dataIndex: "current",
        key: "current",
        width: "7%",
        sortable: true,
    },
    {
        title: `Voltage`,
        dataIndex: "voltage",
        key: "voltage",
        width: "7%",
        sortable: true,
    },
    {
        title: `Configuration`,
        dataIndex: "configuration",
        key: "configuration",
        width: "7%",
        sortable: true,
    },
    {
        title: `Max BHT`,
        dataIndex: "max_BHT",
        key: "max_BHT",
        width: "7%",
        sortable: true,
    },
    {
        title: `Size`,
        dataIndex: "size",
        key: "size",
        width: "5%",
        sortable: true,
    },
    {
        title: `Temp unit`,
        dataIndex: "tempUnit",
        key: "tempUnit",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Base connection`,
        dataIndex: "baseConnection",
        key: "baseConnection",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Standardization`,
        dataIndex: "std",
        key: "std",
        width: "7%",
        sortable: true,
    },
];

export const SrProtectors = [
    {
        title: `Protector`,
        dataIndex: "name",
        key: "name",
        width: "7%",
        sortable: true,
    },
    {
        title: `Equipment`,
        dataIndex: "pN_Description",
        key: "pN_Description",
        width: "9%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "equipmentStatus",
        width: "7%",
        sortable: true,
    },
    {
        title: `PN`,
        dataIndex: "pn",
        key: "pn",
        width: "7%",
        sortable: true,
    },
    {
        title: `Length`,
        dataIndex: "length",
        key: "length",
        width: "7%",
        sortable: true,
    },
    {
        title: `Weight`,
        dataIndex: "weight",
        key: "weight",
        width: "7%",
        sortable: true,
    },
    {
        title: `Series`,
        dataIndex: "series",
        key: "series",
        width: "7%",
        sortable: true,
    },
    {
        title: `OD`,
        dataIndex: "od",
        key: "od",
        width: "7%",
        sortable: true,
    },
    {
        title: `Shaft material`,
        dataIndex: "shaftMaterial",
        key: "shaftMaterial",
        width: "7%",
        sortable: true,
    },
    {
        title: `Bearing Type`,
        dataIndex: "bearingType",
        key: "bearingType",
        width: "7%",
        sortable: true,
    },
    {
        title: `Model`,
        dataIndex: "model",
        key: "model",
        width: "7%",
        sortable: true,
    },
    {
        title: `Configuration`,
        dataIndex: "configuration",
        key: "configuration",
        width: "7%",
        sortable: true,
    },
    {
        title: `Standardization`,
        dataIndex: "standardization",
        key: "standardization",
        width: "7%",
        sortable: true,
    }
];

export const SrPumps = [
    {
        title: `Pump`,
        dataIndex: "pump",
        key: "pump",
        width: "16%",
        sortable: true,
    },
    {
        title: `Equipment`,
        dataIndex: "pN_Description",
        key: "pN_Description",
        width: "12%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "equipmentStatus",
        width: "8%",
        sortable: true,
    },
    {
        title: `No of Stages`,
        dataIndex: "noStgs",
        key: "noStgs",
        width: "8%",
        sortable: true,
    },
    {
        title: `PN`,
        dataIndex: "partNumber",
        key: "partNumber",
        width: "8%",
        sortable: true,
    },
    {
        title: `Length`,
        dataIndex: "length",
        key: "length",
        width: "8%",
        sortable: true,
    },
    {
        title: `Weight`,
        dataIndex: "weight",
        key: "weight",
        width: "8%",
        sortable: true,
    },
    {
        title: `Series`,
        dataIndex: "series",
        key: "series",
        width: "8%",
        sortable: true,
    },
    {
        title: `OD`,
        dataIndex: "od",
        key: "od",
        width: "8%",
        sortable: true,
    },
    {
        title: `Shaft type`,
        dataIndex: "shaftType",
        key: "shaftType",
        width: "8%",
        sortable: true,
    },
    {
        title: `Standardization`,
        dataIndex: "standardization",
        key: "standardization",
        width: "8%",
        sortable: true,
    },
];

export const SrSensors = [
    {
        title: `Sensor`,
        dataIndex: "name",
        key: "name",
        width: "12%",
        sortable: true,
    },
    {
        title: `Equipment`,
        dataIndex: "pN_Description",
        key: "pN_Description",
        width: "23%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "status",
        key: "status",
        width: "10%",
        sortable: true,
    },
    {
        title: `PN`,
        dataIndex: "pn",
        key: "pn",
        width: "10%",
        sortable: true,
    },
    {
        title: `Length`,
        dataIndex: "length",
        key: "length",
        width: "10%",
        sortable: true,
    },
    {
        title: `Weight`,
        dataIndex: "weight",
        key: "weight",
        width: "10%",
        sortable: true,
    },
    {
        title: `Diameter`,
        dataIndex: "diameter",
        key: "diameter",
        width: "10%",
        sortable: true,
    },
    {
        title: `Standardization`,
        dataIndex: "standardization",
        key: "standardization",
        width: "10%",
        sortable: true,
    },
];

export const SrTransformers = [
    {
        title: `Transformer`,
        dataIndex: "transformers",
        key: "transformers",
        width: "20%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "equipmentStatus",
        width: "10%",
        sortable: true,
    },
    {
        title: `PN`,
        dataIndex: "trnsf__P_N",
        key: "trnsf__P_N",
        width: "12.5%",
        sortable: true,
    },
    {
        title: `KVA`,
        dataIndex: "kva",
        key: "kva",
        width: "12.5%",
        sortable: true,
    },
    {
        title: `Sec`,
        dataIndex: "sec",
        key: "sec",
        width: "12.5%",
        sortable: true,
    },
    {
        title: `Sec Y`,
        dataIndex: "sec_Y",
        key: "sec_Y",
        width: "12.5%",
        sortable: true,
    },
    {
        title: `Standardization`,
        dataIndex: "standardization",
        key: "standardization",
        width: "10%",
        sortable: true,
    }
];

export const SrVSDs = [
    {
        title: `VSD`,
        dataIndex: "aalS_Description",
        key: "aalS_Description",
        width: "30%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "status",
        key: "status",
        width: "16%",
        sortable: true,
    },
    {
        title: `PN`,
        dataIndex: "oracle_Item_Number",
        key: "oracle_Item_Number",
        width: "16%",
        sortable: true,
    },
    {
        title: `Power`,
        dataIndex: "power",
        key: "power",
        width: "16%",
        sortable: true,
    },
    {
        title: `UOM`,
        dataIndex: "uom",
        key: "uom",
        width: "16%",
        sortable: true,
    },
    {
        title: `Standardization`,
        dataIndex: "std",
        key: "std",
        width: "16%",
        sortable: true,
    },
];

export const HarmonicFilters = [
    {
        title: `Harmonic Filter`,
        dataIndex: "harmonicFilters",
        key: "harmonicFilters",
        width: "22%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "status",
        key: "status",
        width: "10%",
        sortable: true,
    },
    {
        title: `PN`,
        dataIndex: "harmPN",
        key: "harmPN",
        width: "13%",
        sortable: true,
    },
    {
        title: `Filter Type`,
        dataIndex: "filterType",
        key: "filterType",
        width: "11%",
        sortable: true,
    },
    {
        title: `Amps Filter`,
        dataIndex: "ampsFilter",
        key: "ampsFilter",
        width: "11%",
        sortable: true,
    },
    {
        title: `Low Limit Amps`,
        dataIndex: "lowLimitAmps",
        key: "lowLimitAmps",
        width: "11%",
        sortable: true,
    },
    {
        title: `High Limit Amps`,
        dataIndex: "highLimitAmps",
        key: "highLimitAmps",
        width: "11%",
        sortable: true,
    },
    {
        title: `Standardization`,
        dataIndex: "standardization",
        key: "standardization",
        width: "11%",
        sortable: true,
    },
];

export const auditLogDrCables = [
    {
        title: `${LABELS?.cable}`,
        dataIndex: "name",
        key: "catalog_name",
        width: "20%",
        sortable: true,
        minwidth: "12rem",
    },
    {
        title: `Action type`,
        dataIndex: "actionType",
        key: "audit_actionType",
        width: "10%",
        sortable: true,
    },
    {
        title: `Created on`,
        dataIndex: "createdOn",
        key: "audit_createdOn",
        width: "10%",
        sortable: true,
        render: (_: string, record: { audit_createdOn: string }) => (
            <>
                {record?.audit_createdOn && moment(record?.audit_createdOn).format("DD MMM YYYY")}
            </>
        ),
    },
    {
        title: `Created by`,
        dataIndex: "createdByName",
        key: "audit_createdByName",
        width: "10%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "catalog_equipmentStatus",
        width: "10%",
        sortable: true,
    },
    {
        title: `Display order`,
        dataIndex: "display_Order",
        key: "catalog_display_Order",
        width: "2.2%",
        sortable: true,
    },
    {
       title: `Awg Id`,
        dataIndex: "awG_id",
        key: "catalog_awG_id",
        width: "2.2%",
        sortable: true, 
    },
    {
        title: `Dimension A`,
        dataIndex: "dimensionA",
        key: "catalog_dimensionA",
        width: "5%",
        sortable: true,
    },
    {
        title: `Dimension B`,
        dataIndex: "dimensionB",
        key: "catalog_dimensionB",
        width: "5%",
        sortable: true,
    },
    {
        title: `V0`,
        dataIndex: "v0",
        key: "catalog_v0",
        width: "5%",
        sortable: true,
    },
    {
        title: `V1`,
        dataIndex: "v1",
        key: "catalog_v1",
        width: "5%",
        sortable: true,
    },
    {
        title: `V2`,
        dataIndex: "v2",
        key: "catalog_v2",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `V3`,
        dataIndex: "v3",
        key: "catalog_v3",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `V4`,
        dataIndex: "v4",
        key: "catalog_v4",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `V5`,
        dataIndex: "v5",
        key: "catalog_v5",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `Profile`,
        dataIndex: "profile",
        key: "catalog_profile",
        width: "5%",
        sortable: true,
    },
    {
        title: `Temp rating F`,
        dataIndex: "tempRating_F",
        key: "catalog_tempRating_F",
        width: "5%",
        sortable: true,
    },
    {
        title: `Temp rating C`,
        dataIndex: "tempRating_C",
        key: "catalog_tempRating_C",
        width: "5%",
        sortable: true,
    },
    {
        title: `Temp correction factor`,
        dataIndex: "tempCorrectionFactor",
        key: "catalog_tempCorrectionFactor",
        width: "5%",
        sortable: true,
    },
    {
        title: `Permian`,
        dataIndex: "permian",
        key: "catalog_permian",
        width: "5%",
        sortable: true,
    },
    {
        title: `International`,
        dataIndex: "international",
        key: "catalog_international",
        width: "5%",
        sortable: true,
    },
];

export const auditLogDrGasHandlers = [
    {
        title: `Gas handler`,
        dataIndex: "pumpName",
        key: "catalog_pumpName",
        width: "20%",
        sortable: true,
    },
    {
        title: `Action type`,
        dataIndex: "actionType",
        key: "audit_actionType",
        width: "10%",
        sortable: true,
    },
    {
        title: `Created on`,
        dataIndex: "createdOn",
        key: "audit_createdOn",
        width: "10%",
        sortable: true,
        render: (_: string, record: { audit_createdOn: string }) => (
            <>
                {record?.audit_createdOn && moment(record?.audit_createdOn).format("DD MMM YYYY")}
            </>
        ),
    },
    {
        title: `Created by`,
        dataIndex: "createdByName",
        key: "audit_createdByName",
        width: "10%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "catalog_equipmentStatus",
        width: "",
        sortable: true,
    },
    {
        title: `No of stages`,
        dataIndex: "noOfStages",
        key: 'catalog_noOfStages',
        width: "",
        sortable: true,
    },
    {
        title: `HP`,
        dataIndex: "hp",
        key: 'catalog_hp',
        width: "3%",
        sortable: true,
    },
    {
        title: `BEP flow`,
        dataIndex: "bepFlow",
        key: "catalog_bepFlow",
        width: "",
        sortable: true,
    },
    {
        title: `Min flow`,
        dataIndex: "minFlow",
        key: "catalog_minFlow",
        width: "",
        sortable: true,
    },
    {
        title: `Max flow`,
        dataIndex: "maxFlow",
        key: "catalog_maxFlow",
        width: "",
        sortable: true,
    },
    {
        title: `Min viscosity`,
        dataIndex: "minViscosity",
        key: "catalog_minViscosity",
        width: "",
        sortable: true,
    },
    {
        title: `Max viscosity`,
        dataIndex: "maxViscosity",
        key: "catalog_maxViscosity",
        width: "",
        sortable: true,
    },
    {
        title: `Shaft OD`,
        dataIndex: "shaftOD",
        key: "catalog_shaftOD",
        width: "",
        sortable: true,
    },
    {
        title: `Std shaft`,
        dataIndex: "stdShaft",
        key: "catalog_stdShaft",
        width: "",
        sortable: true,
    },
    {
        title: `Hs Shaft`,
        dataIndex: "hsShaft",
        key: "catalog_hsShaft",
        width: "",
        sortable: true,
    },
    {
        title: `B0`,
        dataIndex: "b0",
        key: "catalog_b0",
        width: "5%",
        sortable: true,
    },
    {
        title: `B1`,
        dataIndex: "b1",
        key: "catalog_b1",
        width: "5%",
        sortable: true,
    },
    {
        title: `B2`,
        dataIndex: "b2",
        key: "catalog_b2",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `B3`,
        dataIndex: "b3",
        key: "catalog_b3",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `B4`,
        dataIndex: "b4",
        key: "catalog_b4",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `B5`,
        dataIndex: "b5",
        key: "catalog_b5",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `H0`,
        dataIndex: "h0",
        key: "catalog_h0",
        width: "5%",
        sortable: true,
    },
    {
        title: `H1`,
        dataIndex: "h1",
        key: "catalog_h1",
        width: "5%",
        sortable: true,
    },
    {
        title: `H2`,
        dataIndex: "h2",
        key: "catalog_h2",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `H3`,
        dataIndex: "h3",
        key: "catalog_h3",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `H4`,
        dataIndex: "h4",
        key: "catalog_h4",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `H5`,
        dataIndex: "h5",
        key: "catalog_h5",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `VH1`,
        dataIndex: "vH1",
        key: "catalog_vH1",
        width: "5%",
        sortable: true,
    },
    {
        title: `VH2`,
        dataIndex: "vH2",
        key: "catalog_vH2",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `VH3`,
        dataIndex: "vH3",
        key: "catalog_vH3",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `VH4`,
        dataIndex: "vH4",
        key: "catalog_vH4",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `VP1`,
        dataIndex: "vP1",
        key: "catalog_vP1",
        width: "5%",
        sortable: true,
    },
    {
        title: `VP2`,
        dataIndex: "vP2",
        key: "catalog_vP2",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `VP3`,
        dataIndex: "vP3",
        key: "catalog_vP3",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `VP4`,
        dataIndex: "vP4",
        key: "catalog_vP4",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `VQ1`,
        dataIndex: "vQ1",
        key: "catalog_vQ1",
        width: "5%",
        sortable: true,
    },
    {
        title: `VQ2`,
        dataIndex: "vQ2",
        key: "catalog_vQ2",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `VQ3`,
        dataIndex: "vQ3",
        key: "catalog_vQ3",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `VQ4`,
        dataIndex: "vQ4",
        key: "catalog_vQ4",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `Permian`,
        dataIndex: "permian",
        key: "catalog_permian",
        width: "5%",
        sortable: true,
    },
    {
        title: `International`,
        dataIndex: "international",
        key: "catalog_international",
        width: "5%",
        sortable: true,
    },
];

export const auditLogDrGasSeparators = [
    {
        title: `Gas separator`,
        dataIndex: "name",
        key: "catalog_name",
        width: "15%",
        sortable: true,
    },
    {
        title: `Action type`,
        dataIndex: "actionType",
        key: "audit_actionType",
        width: "10%",
        sortable: true,
    },
    {
        title: `Created on`,
        dataIndex: "createdOn",
        key: "audit_createdOn",
        width: "10%",
        sortable: true,
        render: (_: string, record: { audit_createdOn: string }) => (
            <>
                {record?.audit_createdOn && moment(record?.audit_createdOn).format("DD MMM YYYY")}
            </>
        ),
    },
    {
        title: `Created by`,
        dataIndex: "createdByName",
        key: "audit_createdByName",
        width: "10%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "catalog_equipmentStatus",
        width: "15%",
        sortable: true,
    },
    {
        title: `Series`,
        dataIndex: "series",
        key: "catalog_series",
        width: "15%",
        sortable: true,
    },
    {
        title: "Series type",
        dataIndex: "seriesType",
        key: "catalog_seriesType",
        width: "15%",
        sortable: true
    },
    {
        title: `Power`,
        dataIndex: "hp",
        key: "catalog_hp",
        width: "",
        sortable: true,
    },
    {
        title: `Std shaft HP`,
        dataIndex: "stdShaftHP",
        key: "catalog_stdShaftHP",
        width: "",
        sortable: true,
    },
    {
        title: `Hs shaft HP`,
        dataIndex: "hsShaftHP",
        key: "catalog_hsShaftHP",
        width: "",
        sortable: true,
    },
    {
        title: `Max flow`,
        dataIndex: "maxFlow",
        key: "catalog_maxFlow",
        width: "",
        sortable: true,
    },
    {
        title: `Max outer diameter (In)`,
        dataIndex: "maxOuterDiaIn",
        key: "catalog_maxOuterDiaIn",
        width: "",
        sortable: true,
    },
    {
        title: `Max outer diameter (MM)`,
        dataIndex: "maxOuterDiaMM",
        key: "catalog_maxOuterDiaMM",
        width: "",
        sortable: true,
    },
    {
        title: `Permian`,
        dataIndex: "permian",
        key: "catalog_permian",
        width: "5%",
        sortable: true,
    },
    {
        title: `International`,
        dataIndex: "international",
        key: "catalog_international",
        width: "5%",
        sortable: true,
    },
];

export const auditLogDrMotorLeads = [
    {
        title: `Motor lead`,
        dataIndex: "name",
        key: "catalog_name",
        width: "10%",
        sortable: true,
    },
    {
        title: `Action type`,
        dataIndex: "actionType",
        key: "audit_actionType",
        width: "10%",
        sortable: true,
    },
    {
        title: `Created on`,
        dataIndex: "createdOn",
        key: "audit_createdOn",
        width: "10%",
        sortable: true,
        render: (_: string, record: { audit_createdOn: string }) => (
            <>
                {record?.audit_createdOn && moment(record?.audit_createdOn).format("DD MMM YYYY")}
            </>
        ),
    },
    {
        title: `Created by`,
        dataIndex: "createdByName",
        key: "audit_createdByName",
        width: "10%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "catalog_equipmentStatus",
        width: "10%",
        sortable: true,
    },
    {
        title: `Series`,
        dataIndex: "motorSeries",
        key: "catalog_motorSeries",
        width: "10%",
        sortable: true,
    },
    {
        title: `Dimension A`,
        dataIndex: "dimensionA",
        key: "catalog_dimensionA",
        width: "5%",
        sortable: true,
    },
    {
        title: `Dimension B`,
        dataIndex: "dimensionB",
        key: "catalog_dimensionB",
        width: "5%",
        sortable: true,
    },
    {
        title: `Permian`,
        dataIndex: "permian",
        key: "catalog_permian",
        width: "5%",
        sortable: true,
    },
    {
        title: `International`,
        dataIndex: "international",
        key: "catalog_international",
        width: "5%",
        sortable: true,
    },
];

export const auditLogDrMotorSensors = [
    {
        title: `Motor sensor`,
        dataIndex: "name",
        key: "catalog_name",
        width: "15%",
        sortable: true,
    },
    {
        title: `Action type`,
        dataIndex: "actionType",
        key: "audit_actionType",
        width: "9%",
        sortable: true,
    },
    {
        title: `Created on`,
        dataIndex: "createdOn",
        key: "audit_createdOn",
        width: "10%",
        sortable: true,
        render: (_: string, record: { audit_createdOn: string }) => (
            <>
                {record?.audit_createdOn && moment(record?.audit_createdOn).format("DD MMM YYYY")}
            </>
        ),
    },
    {
        title: `Created by`,
        dataIndex: "createdByName",
        key: "audit_createdByName",
        width: "10%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "catalog_equipmentStatus",
        width: "9%",
        sortable: true,
    },
    {
        title: `Series`,
        dataIndex: "series",
        key: "catalog_series",
        width: "9%",
        sortable: true,
    },
    {
        title: `Pn`,
        dataIndex: "pn",
        key: "catalog_pn",
        width: "10%",
        sortable: true,
    },
    {
        title: `Length`,
        dataIndex: "length",
        key: "catalog_length",
        width: "10%",
        sortable: true,
    },
    {
        title: `Weight`,
        dataIndex: "weight",
        key: "catalog_weight",
        width: "10%",
        sortable: true,
    },
    {
        title: `Diameter`,
        dataIndex: "diameter",
        key: "catalog_diameter",
        width: "10%",
        sortable: true,
    },
    {
        title: `Permian`,
        dataIndex: "permian",
        key: "catalog_permian",
        width: "9%",
        sortable: true,
    },
    {
        title: `International`,
        dataIndex: "international",
        key: "catalog_international",
        width: "9%",
        sortable: true,
    },
];

export const auditLogDrMotors = [
    {
        title: `Motor`,
        dataIndex: "name",
        key: "catalog_name",
        width: "8%",
        sortable: true,
    },
    {
        title: `Action type`,
        dataIndex: "actionType",
        key: "audit_actionType",
        width: "8%",
        sortable: true,
    },
    {
        title: `Created on`,
        dataIndex: "createdOn",
        key: "audit_createdOn",
        width: "10%",
        sortable: true,
        render: (_: string, record: { audit_createdOn: string }) => (
            <>
                {record?.audit_createdOn && moment(record?.audit_createdOn).format("DD MMM YYYY")}
            </>
        ),
    },
    {
        title: `Created by`,
        dataIndex: "createdByName",
        key: "audit_createdByName",
        width: "10%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "catalog_equipmentStatus",
        width: "8%",
        sortable: true,
    },
    {
        title: `No of motors`,
        dataIndex: "noOfMotors",
        key: "catalog_noOfMotors",
        width: "8%",
        sortable: true,
    },
    {
        title: `Series`,
        dataIndex: "series",
        key: "catalog_series",
        width: "8%",
        sortable: true,
    },
    {
        title: `Series type`,
        dataIndex: "seriesType",
        key: "catalog_seriesType",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `Display order`,
        dataIndex: "display_Order",
        key: "catalog_display_Order",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `Size`,
        dataIndex: "size",
        key: "catalog_size",
        width: "5%",
        sortable: true,
    },
    {
        title: `Current`,
        dataIndex: "current",
        key: "catalog_current",
        width: "8%",
        sortable: true,
    },
    {
        title: `Voltage`,
        dataIndex: "voltage",
        key: "catalog_voltage",
        width: "8%",
        sortable: true,
    },
    {
        title: "Base HP",
        dataIndex: "baseHP",
        key: "catalog_baseHP",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `KW`,
        dataIndex: "kw",
        key: "catalog_kw",
        width: "8%",
        sortable: true,
    },
    {
        title: `Motor OD`,
        dataIndex: "motorOD",
        key: "catalog_motorOD",
        width: "8%",
        sortable: true,
    },
    {
        title: `Min casing size`,
        dataIndex: "minCasingSize",
        key: "catalog_minCasingSize",
        width: "8%",
        sortable: true,
    },
    {
        title: `Max operating temp`,
        dataIndex: "maxOperatingTemp",
        key: "catalog_maxOperatingTemp",
        width: "8%",
        sortable: true,
    },
    {
        title: `Max bottom hole temp`,
        dataIndex: "maxBottomHoleTemp",
        key: "catalog_maxBottomHoleTemp",
        width: "8%",
        sortable: true,
    },
    {
        title: `C0`,
        dataIndex: "c0",
        key: "catalog_c0",
        width: "5%",
        sortable: true,
    },
    {
        title: `C1`,
        dataIndex: "c1",
        key: "catalog_c1",
        width: "5%",
        sortable: true,
    },
    {
        title: `C2`,
        dataIndex: "c2",
        key: "catalog_c2",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `C3`,
        dataIndex: "c3",
        key: "catalog_c3",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `C4`,
        dataIndex: "c4",
        key: "catalog_c4",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `C5`,
        dataIndex: "c5",
        key: "catalog_c5",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `E0`,
        dataIndex: "e0",
        key: "catalog_e0",
        width: "5%",
        sortable: true,
    },
    {
        title: `E1`,
        dataIndex: "e1",
        key: "catalog_e1",
        width: "5%",
        sortable: true,
    },
    {
        title: `E2`,
        dataIndex: "e2",
        key: "catalog_e2",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `E3`,
        dataIndex: "e3",
        key: "catalog_e3",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `E4`,
        dataIndex: "e4",
        key: "catalog_e4",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `E5`,
        dataIndex: "e5",
        key: "catalog_e5",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `H0`,
        dataIndex: "h0",
        key: "catalog_h0",
        width: "5%",
        sortable: true,
    },
    {
        title: `H1`,
        dataIndex: "h1",
        key: "catalog_h1",
        width: "5%",
        sortable: true,
    },
    {
        title: `H2`,
        dataIndex: "h2",
        key: "catalog_h2",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `H3`,
        dataIndex: "h3",
        key: "catalog_h3",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `H4`,
        dataIndex: "h4",
        key: "catalog_h4",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `H5`,
        dataIndex: "h5",
        key: "catalog_h5",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `P0`,
        dataIndex: "p0",
        key: "catalog_p0",
        width: "5%",
        sortable: true,
    },
    {
        title: `P1`,
        dataIndex: "p1",
        key: "catalog_p1",
        width: "5%",
        sortable: true,
    },
    {
        title: `P2`,
        dataIndex: "p2",
        key: "catalog_p2",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `P3`,
        dataIndex: "p3",
        key: "catalog_p3",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `P4`,
        dataIndex: "p4",
        key: "catalog_p4",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `P5`,
        dataIndex: "p5",
        key: "catalog_p5",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `S0`,
        dataIndex: "s0",
        key: "catalog_s0",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `S1`,
        dataIndex: "s1",
        key: "catalog_s1",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `S2`,
        dataIndex: "s2",
        key: "catalog_s2",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `S3`,
        dataIndex: "s3",
        key: "catalog_s3",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `S4`,
        dataIndex: "s4",
        key: "catalog_s4",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `S5`,
        dataIndex: "s5",
        key: "catalog_s5",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `V0`,
        dataIndex: "v0",
        key: "catalog_v0",
        width: "5%",
        sortable: true,
    },
    {
        title: `V1`,
        dataIndex: "v1",
        key: "catalog_v1",
        width: "5%",
        sortable: true,
    },
    {
        title: `V2`,
        dataIndex: "v2",
        key: "catalog_v2",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `V3`,
        dataIndex: "v3",
        key: "catalog_v3",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `V4`,
        dataIndex: "v4",
        key: "catalog_v4",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `V5`,
        dataIndex: "v5",
        key: "catalog_v5",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `Permian`,
        dataIndex: "permian",
        key: "catalog_permian",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `International`,
        dataIndex: "international",
        key: "catalog_international",
        width: "2.5%",
        sortable: true,
    },
];

export const auditLogDrProtectors = [
    {
        title: `Protector`,
        dataIndex: "name",
        key: "catalog_name",
        width: "15%",
        sortable: true,
    },
    {
        title: `Action type`,
        dataIndex: "actionType",
        key: "audit_actionType",
        width: "8%",
        sortable: true,
    },
    {
        title: `Created on`,
        dataIndex: "createdOn",
        key: "audit_createdOn",
        width: "10%",
        sortable: true,
        render: (_: string, record: { audit_createdOn: string }) => (
            <>
                {record?.audit_createdOn && moment(record?.audit_createdOn).format("DD MMM YYYY")}
            </>
        ),
    },
    {
        title: `Created by`,
        dataIndex: "createdByName",
        key: "audit_createdByName",
        width: "10%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "catalog_equipmentStatus",
        width: "15%",
        sortable: true,
    },
    {
        title: `Series`,
        dataIndex: "series",
        key: "catalog_series",
        width: "15%",
        sortable: true,
    },
    {
        title: `Display order`,
        dataIndex: "display_Order",
        key: "catalog_display_Order",
        width: "8%",
        sortable: true,
    },
    {
        title: `OD`,
        dataIndex: "od",
        key: "catalog_od",
        width: "8%",
        sortable: true,
    },
    {
        title: `Model`,
        dataIndex: "model",
        key: "catalog_model",
        width: "15%",
        sortable: true,
    },
    {
        title: `Temp rating`,
        dataIndex: "tempRating",
        key: "catalog_tempRating",
        width: "15%",
        sortable: true,
    },
    {
        title: `Power`,
        dataIndex: "hp",
        key: "catalog_hp",
        width: "",
        sortable: true,
    },
    {
        title: `Std shaft HP`,
        dataIndex: "stdShaftHP",
        key: "catalog_stdShaftHP",
        width: "",
        sortable: true,
    },
    {
        title: `Hs shaft HP`,
        dataIndex: "hsShaftHP",
        key: "catalog_hsShaftHP",
        width: "",
        sortable: true,
    },
    {
        title: `Std bearing max load`,
        dataIndex: "stdBearingMaxLoad",
        key: "catalog_stdBearingMaxLoad",
        width: "",
        sortable: true,
    },
    {
        title: `Hs bearing max load`,
        dataIndex: "hsBearingMaxLoad",
        key: "catalog_hsBearingMaxLoad",
        width: "",
        sortable: true,
    },
    {
        title: `Max outer diameter (In)`,
        dataIndex: "maxOuterDiaIn",
        key: "catalog_maxOuterDiaIn",
        width: "",
        sortable: true,
    },
    {
        title: `Max outer diameter (mm)`,
        dataIndex: "maxOuterDiaMM",
        key: "catalog_maxOuterDiaMM",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Volume 1`,
        dataIndex: "chamber1Vol",
        key: "catalog_chamber1Vol",
        width: "",
        sortable: true,
    },
    {
        title: `Volume 2`,
        dataIndex: "chamber2Vol",
        key: "catalog_chamber2Vol",
        width: "",
        sortable: true,
    },
    {
        title: `Volume 3`,
        dataIndex: "chamber3Vol",
        key: "catalog_chamber3Vol",
        width: "",
        sortable: true,
    },
    {
        title: `Volume 4`,
        dataIndex: "chamber4Vol",
        key: "catalog_chamber4Vol",
        width: "",
        sortable: true,
    },
    {
        title: `Permian`,
        dataIndex: "permian",
        key: "catalog_permian",
        width: "5%",
        sortable: true,
    },
    {
        title: `International`,
        dataIndex: "international",
        key: "catalog_international",
        width: "5%",
        sortable: true,
    },
];

export const auditLogDrPumps = [
    {
        title: `Pump`,
        dataIndex: "pump",
        key: "catalog_pump",
        width: "8%",
        sortable: true,
    },
    {
        title: `Action type`,
        dataIndex: "actionType",
        key: "audit_actionType",
        width: "8%",
        sortable: true,
    },
    {
        title: `Created on`,
        dataIndex: "createdOn",
        key: "audit_createdOn",
        width: "10%",
        sortable: true,
        render: (_: string, record: { audit_createdOn: string }) => (
            <>
                {record?.audit_createdOn && moment(record?.audit_createdOn).format("DD MMM YYYY")}
            </>
        ),
    },
    {
        title: `Created by`,
        dataIndex: "createdByName",
        key: "audit_createdByName",
        width: "10%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "catalog_equipmentStatus",
        width: "8%",
        sortable: true,
    },
    {
        title: `Series`,
        dataIndex: "series",
        key: "catalog_series",
        width: "8%",
        sortable: true,
    },
    {
        title: `Display order`,
        dataIndex: "display_Order",
        key: "catalog_display_Order",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `OD`,
        dataIndex: "od",
        key: "catalog_od",
        width: "8%",
        sortable: true,
    },
    {
        title: `Min casing size`,
        dataIndex: "minCasingSize",
        key: "catalog_minCasingSize",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Nominal casing size`,
        dataIndex: "nominalCasingSize",
        key: "catalog_nominalCasingSize",
        width: "8%",
        sortable: true,
    },
    {
        title: `Housing type`,
        dataIndex: "housingType",
        key: "catalog_housingType",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Shaft`,
        dataIndex: "shaft",
        key: "catalog_shaft",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `BEP flow`,
        dataIndex: "bepFlow",
        key: "catalog_bepFlow",
        width: "8%",
        sortable: true,
    },
    {
        title: `Comp thrust`,
        dataIndex: "compThrust",
        key: "catalog_compThrust",
        width: "8%",
        sortable: true,
    },
    {
        title: `Legacy`,
        dataIndex: "legacy",
        key: "catalog_legacy",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `Operating BPD range`,
        dataIndex: "operatingBPDRange",
        key: "catalog_operatingBPDRange",
        width: "8%",
        sortable: true,
    },
    {
        title: `Std shaft`,
        dataIndex: "stdShaft",
        key: "catalog_stdShaft",
        width: "",
        sortable: true,
    },
    {
        title: `Hs Shaft`,
        dataIndex: "hsShaft",
        key: "catalog_hsShaft",
        width: "",
        sortable: true,
    },
    {
        title: `Std housing`,
        dataIndex: "stdHousing",
        key: "catalog_stdHousing",
        width: "",
        sortable: true,
    },
    {
        title: `Hs housing`,
        dataIndex: "hsHousing",
        key: "catalog_hsHousing",
        width: "",
        sortable: true,
    },
    {
        title: `Impeller flow`,
        dataIndex: "impellerFlow",
        key: "catalog_impellerFlow",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `Min operating BPD`,
        dataIndex: "minOperatingBPD",
        key: "catalog_minOperatingBPD",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `Max operating BPD`,
        dataIndex: "maxOperatingBPD",
        key: "catalog_maxOperatingBPD",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `Max plotted production`,
        dataIndex: "maxPlottedProduction",
        key: "catalog_maxPlottedProduction",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Shaft Dia (mm)`,
        dataIndex: "shaftDiaMM",
        key: "catalog_shaftDiaMM",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `Plot x space`,
        dataIndex: "plot_x_Space",
        key: "catalog_plot_x_Space",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `Plot x space metric`,
        dataIndex: "plot_x_Space_Metric",
        key: "catalog_plot_x_Space_Metric",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `Plot eff intervals`,
        dataIndex: "plot_Eff_Intervals",
        key: "catalog_plot_Eff_Intervals",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `Shaft area`,
        dataIndex: "shaftArea",
        key: "catalog_shaftArea",
        width: "",
        sortable: true,
    },
    {
        title: `Min viscosity`,
        dataIndex: "minViscosity",
        key: "catalog_minViscosity",
        width: "",
        sortable: true,
    },
    {
        title: `Max viscosity`,
        dataIndex: "maxViscosity",
        key: "catalog_maxViscosity",
        width: "",
        sortable: true,
    },
    {
        title: "BEP lift per stage",
        dataIndex: "bepLiftPerStage",
        key: "catalog_bepLiftPerStage",
        width: "5.5%",
        sortable: true,
    },
    {
        title: "BEP power per stage",
        dataIndex: "bepPowerPerStage",
        key: "catalog_bepPowerPerStage",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `B0`,
        dataIndex: "b0",
        key: "catalog_b0",
        width: "5%",
        sortable: true,
    },
    {
        title: `B1`,
        dataIndex: "b1",
        key: "catalog_b1",
        width: "5%",
        sortable: true,
    },
    {
        title: `B2`,
        dataIndex: "b2",
        key: "catalog_b2",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `B3`,
        dataIndex: "b3",
        key: "catalog_b3",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `B4`,
        dataIndex: "b4",
        key: "catalog_b4",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `B5`,
        dataIndex: "b5",
        key: "catalog_b5",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `H0`,
        dataIndex: "h0",
        key: "catalog_h0",
        width: "5%",
        sortable: true,
    },
    {
        title: `H1`,
        dataIndex: "h1",
        key: "catalog_h1",
        width: "5%",
        sortable: true,
    },
    {
        title: `H2`,
        dataIndex: "h2",
        key: "catalog_h2",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `H3`,
        dataIndex: "h3",
        key: "catalog_h3",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `H4`,
        dataIndex: "h4",
        key: "catalog_h4",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `H5`,
        dataIndex: "h5",
        key: "catalog_h5",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `VH1`,
        dataIndex: "vH1",
        key: "catalog_vH1",
        width: "5%",
        sortable: true,
    },
    {
        title: `VH2`,
        dataIndex: "vH2",
        key: "catalog_vH2",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `VH3`,
        dataIndex: "vH3",
        key: "catalog_vH3",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `VH4`,
        dataIndex: "vH4",
        key: "catalog_vH4",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `VP1`,
        dataIndex: "vP1",
        key: "catalog_vP1",
        width: "5%",
        sortable: true,
    },
    {
        title: `VP2`,
        dataIndex: "vP2",
        key: "catalog_vP2",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `VP3`,
        dataIndex: "vP3",
        key: "catalog_vP3",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `VP4`,
        dataIndex: "vP4",
        key: "catalog_vP4",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `VQ1`,
        dataIndex: "vQ1",
        key: "catalog_vQ1",
        width: "5%",
        sortable: true,
    },
    {
        title: `VQ2`,
        dataIndex: "vQ2",
        key: "catalog_vQ2",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `VQ3`,
        dataIndex: "vQ3",
        key: "catalog_vQ3",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `VQ4`,
        dataIndex: "vQ4",
        key: "catalog_vQ4",
        width: "2.5%",
        sortable: true,
    },
    {
        title: `Permian`,
        dataIndex: "permian",
        key: "catalog_permian",
        width: "5%",
        sortable: true,
    },
    {
        title: `International`,
        dataIndex: "international",
        key: "catalog_international",
        width: "5%",
        sortable: true,
    },
];

export const auditLogDrSwitchBoard = [
    {
        title: `Switch board`,
        dataIndex: "description",
        key: "catalog_description",
        width: "28%",
        sortable: true,
    },
    {
        title: `Action type`,
        dataIndex: "actionType",
        key: "audit_actionType",
        width: "12%",
        sortable: true,
    },
    {
        title: `Created on`,
        dataIndex: "createdOn",
        key: "audit_createdOn",
        width: "10%",
        sortable: true,
        render: (_: string, record: { audit_createdOn: string }) => (
            <>
                {record?.audit_createdOn && moment(record?.audit_createdOn).format("DD MMM YYYY")}
            </>
        ),
    },
    {
        title: `Created by`,
        dataIndex: "createdByName",
        key: "audit_createdByName",
        width: "10%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "catalog_equipmentStatus",
        width: "12%",
        sortable: true,
    },
    {
        title: `Voltage`,
        dataIndex: "voltage",
        key: "catalog_voltage",
        width: "12%",
        sortable: true,
    },
    {
        title: "Control",
        dataIndex: "control",
        key: "catalog_control",
        width: "12%",
        sortable: true
    },
    {
        title: `Permian`,
        dataIndex: "permian",
        key: "catalog_permian",
        width: "12%",
        sortable: true,
    },
    {
        title: `International`,
        dataIndex: "international",
        key: "catalog_international",
        width: "12%",
        sortable: true,
    },
];

export const auditLogDrVSD = [
    {
        title: `VSD`,
        dataIndex: "description",
        key: "catalog_description",
        width: "12%",
        sortable: true,
    },
    {
        title: `Action type`,
        dataIndex: "actionType",
        key: "audit_actionType",
        width: "8%",
        sortable: true,
    },
    {
        title: `Created on`,
        dataIndex: "createdOn",
        key: "audit_createdOn",
        width: "10%",
        sortable: true,
        render: (_: string, record: { audit_createdOn: string }) => (
            <>
                {record?.audit_createdOn && moment(record?.audit_createdOn).format("DD MMM YYYY")}
            </>
        ),
    },
    {
        title: `Created by`,
        dataIndex: "createdByName",
        key: "audit_createdByName",
        width: "10%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "catalog_equipmentStatus",
        width: "8%",
        sortable: true,
    },
    {
        title: `Voltage`,
        dataIndex: "voltage",
        key: "catalog_voltage",
        width: "8%",
        sortable: true,
    },
    {
        title: "Power",
        dataIndex: "power",
        key: "catalog_power",
        width: "8%",
        sortable: true
    },
    {
        title: `Current in`,
        dataIndex: "current_In",
        key: "catalog_current_In",
        width: "8%",
        sortable: true,
    },
    {
        title: `Current out`,
        dataIndex: "current_Out",
        key: "catalog_current_Out",
        width: "8%",
        sortable: true,
    },
    {
        title: `Weight lb`,
        dataIndex: "weight_lb",
        key: "catalog_weight_lb",
        width: "8%",
        sortable: true,
    },
    {
        title: `Weight kg`,
        dataIndex: "weight_Kg",
        key: "catalog_weight_Kg",
        width: "8%",
        sortable: true,
    },
    {
        title: `Make`,
        dataIndex: "make",
        key: "catalog_make",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `phase`,
        dataIndex: "phase",
        key: "catalog_phase",
        width: "8%",
        sortable: true,
    },
    {
        title: `pulse`,
        dataIndex: "pulse",
        key: "catalog_pulse",
        width: "8%",
        sortable: true,
    },
    {
        title: `enclosure`,
        dataIndex: "enclosure",
        key: "catalog_enclosure",
        width: "8%",
        sortable: true,
    },
    {
        title: `Permian`,
        dataIndex: "permian",
        key: "catalog_permian",
        width: "2.2%",
        sortable: true,
    },
    {
        title: `International`,
        dataIndex: "international",
        key: "catalog_international",
        width: "2.2%",
        sortable: true,
    },
];

export const auditLogSrAccAboveESP = [
    {
        title: `ACC above ESP`,
        dataIndex: "accAboveESP",
        key: "catalog_accAboveESP",
        width: "10%",
        sortable: true,
    },
    {
        title: `Action type`,
        dataIndex: "actionType",
        key: "audit_actionType",
        width: "8%",
        sortable: true,
    },
    {
        title: `Created on`,
        dataIndex: "createdOn",
        key: "audit_createdOn",
        width: "10%",
        sortable: true,
        render: (_: string, record: { audit_createdOn: string }) => (
            <>
                {record?.audit_createdOn && moment(record?.audit_createdOn).format("DD MMM YYYY")}
            </>
        ),
    },
    {
        title: `Created by`,
        dataIndex: "createdByName",
        key: "audit_createdByName",
        width: "10%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "catalog_equipmentStatus",
        width: "10%",
        sortable: true,
    },
    {
        title: `PN`,
        dataIndex: "pn",
        key: "catalog_pn",
        width: "10%",
        sortable: true,
    },
    {
        title: `Length`,
        dataIndex: "length",
        key: "catalog_length",
        width: "10%",
        sortable: true,
    },
    {
        title: `Weight`,
        dataIndex: "weight",
        key: "catalog_weight",
        width: "10%",
        sortable: true,
    },
    {
        title: `Diameter`,
        dataIndex: "diameter",
        key: "catalog_diameter",
        width: "10%",
        sortable: true,
    },
    {
        title: `Masked diameter`,
        dataIndex: "masked_Diam",
        key: "catalog_masked_Diam",
        width: "10%",
        sortable: true,
    }
];

export const auditLogSrAccBelowESP = [
    {
        title: `ACC below ESP`,
        dataIndex: "accBelowESP",
        key: "catalog_accBelowESP",
        width: "15%",
        sortable: true,
    },
    {
        title: `Action type`,
        dataIndex: "actionType",
        key: "audit_actionType",
        width: "8%",
        sortable: true,
    },
    {
        title: `Created on`,
        dataIndex: "createdOn",
        key: "audit_createdOn",
        width: "10%",
        sortable: true,
        render: (_: string, record: { audit_createdOn: string }) => (
            <>
                {record?.audit_createdOn && moment(record?.audit_createdOn).format("DD MMM YYYY")}
            </>
        ),
    },
    {
        title: `Created by`,
        dataIndex: "createdByName",
        key: "audit_createdByName",
        width: "10%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "catalog_equipmentStatus",
        width: "10%",
        sortable: true,
    },
    {
        title: `PN`,
        dataIndex: "pn",
        key: "catalog_pn",
        width: "10%",
        sortable: true,
    },
    {
        title: `Length`,
        dataIndex: "length",
        key: "catalog_length",
        width: "10%",
        sortable: true,
    },
    {
        title: `Weight`,
        dataIndex: "weight",
        key: "catalog_weight",
        width: "10%",
        sortable: true,
    },
    {
        title: `Diameter`,
        dataIndex: "diameter",
        key: "catalog_diameter",
        width: "10%",
        sortable: true,
    },
    {
        title: `Casing diameter`,
        dataIndex: "casing_Diam__In",
        key: "catalog_casing_Diam__In",
        width: "10%",
        sortable: true,
    },
];

export const auditLogSrBOH = [
    {
        title: `BOH`,
        dataIndex: "boh",
        key: "catalog_boh",
        width: "10%",
        sortable: true,
    },
    {
        title: `Action type`,
        dataIndex: "actionType",
        key: "audit_actionType",
        width: "8%",
        sortable: true,
    },
    {
        title: `Created on`,
        dataIndex: "createdOn",
        key: "audit_createdOn",
        width: "10%",
        sortable: true,
        render: (_: string, record: { audit_createdOn: string }) => (
            <>
                {record?.audit_createdOn && moment(record?.audit_createdOn).format("DD MMM YYYY")}
            </>
        ),
    },
    {
        title: `Created by`,
        dataIndex: "createdByName",
        key: "audit_createdByName",
        width: "10%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "catalog_equipmentStatus",
        width: "10%",
        sortable: true,
    },
    {
        title: `PN`,
        dataIndex: "boH_PN",
        key: "catalog_boH_PN",
        width: "10%",
        sortable: true,
    },
    {
        title: `Length`,
        dataIndex: "length",
        key: "catalog_length",
        width: "10%",
        sortable: true,
    },
    {
        title: `Weight`,
        dataIndex: "weight",
        key: "catalog_weight",
        width: "10%",
        sortable: true,
    },
    {
        title: `Series`,
        dataIndex: "series",
        key: "catalog_series",
        width: "10%",
        sortable: true,
    },
    {
        title: `OD`,
        dataIndex: "od",
        key: "catalog_od",
        width: "10%",
        sortable: true,
    },
    {
        title: `TubingOD`,
        dataIndex: "tubingOD",
        key: "catalog_tubingOD",
        width: "10%",
        sortable: true,
    },
    {
        title: `Tubing`,
        dataIndex: "tubing",
        key: "catalog_tubing",
        width: "10%",
        sortable: true,
    },
];

export const auditLogSrCables = [
    {
        title: `Cable`,
        dataIndex: "pN_Description",
        key: "catalog_pN_Description",
        width: "8.8%",
        sortable: true,
    },
    {
        title: `Action type`,
        dataIndex: "actionType",
        key: "audit_actionType",
        width: "7.6%",
        sortable: true,
    },
    {
        title: `Created on`,
        dataIndex: "createdOn",
        key: "audit_createdOn",
        width: "10%",
        sortable: true,
        render: (_: string, record: { audit_createdOn: string }) => (
            <>
                {record?.audit_createdOn && moment(record?.audit_createdOn).format("DD MMM YYYY")}
            </>
        ),
    },
    {
        title: `Created by`,
        dataIndex: "createdByName",
        key: "audit_createdByName",
        width: "10%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "catalog_equipmentStatus",
        width: "7.6%",
        sortable: true,
    },
    {
        title: `PN`,
        dataIndex: "pn",
        key: "catalog_pn",
        width: "7.6%",
        sortable: true,
    },
    {
        title: `Weight`,
        dataIndex: "nominalWeight",
        key: "catalog_nominalWeight",
        width: "7.6%",
        sortable: true,
    },
    {
        title: `Material`,
        dataIndex: "armorMaterial",
        key: "catalog_armorMaterial",
        width: "7.6%",
        sortable: true,
    },
    {
        title: `Dimension`,
        dataIndex: "dimensions",
        key: "catalog_dimensions",
        width: "7.6%",
        sortable: true,
    },
    {
        title: `Insulation`,
        dataIndex: "insulation",
        key: "catalog_insulation",
        width: "7.6%",
        sortable: true,
    },
    {
        title: `Temp rating`,
        dataIndex: "tempRating__C_",
        key: "catalog_tempRating__C_",
        width: "7.6%",
        sortable: true,
    },
    {
        title: `Voltage rating`,
        dataIndex: "voltRating_KV_",
        key: "catalog_voltRating_KV_",
        width: "7.6%",
        sortable: true,
    },
    {
       title: `Awg Id`,
        dataIndex: "awG_id",
        key: "catalog_awG_id",
        width: "5.5%",
        sortable: true, 
    },
    {
        title: `Barrier`,
        dataIndex: "barrier",
        key: "catalog_barrier",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Profile`,
        dataIndex: "profile",
        key: "catalog_profile",
        width: "7.6%",
        sortable: true,
    },
    {
        title: `standardization`,
        dataIndex: "standardization",
        key: "catalog_standardization",
        width: "7.6%",
        sortable: true,
    }
];

export const auditLogSrGasHandlers = [
    {
        title: `Gas handler`,
        dataIndex: "pumpName",
        key: "catalog_pumpName",
        width: "9%",
        sortable: true,
    },
    {
        title: `Equipment name`,
        dataIndex: "gas_Handling",
        key: "catalog_gas_Handling",
        width: "8%",
        sortable: true,
    },
    {
        title: `Action type`,
        dataIndex: "actionType",
        key: "audit_actionType",
        width: "8%",
        sortable: true,
    },
    {
        title: `Created on`,
        dataIndex: "createdOn",
        key: "audit_createdOn",
        width: "10%",
        sortable: true,
        render: (_: string, record: { audit_createdOn: string }) => (
            <>
                {record?.audit_createdOn && moment(record?.audit_createdOn).format("DD MMM YYYY")}
            </>
        ),
    },
    {
        title: `Created by`,
        dataIndex: "createdByName",
        key: "audit_createdByName",
        width: "10%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "catalog_equipmentStatus",
        width: "8%",
        sortable: true,
    },
    {
        title: `No of stages`,
        dataIndex: "noStages",
        key: "catalog_noStages",
        width: "8%",
        sortable: true,
    },
    {
        title: `PN`,
        dataIndex: "pn",
        key: "catalog_pn",
        width: "8%",
        sortable: true,
    },
    {
        title: `Length`,
        dataIndex: "length",
        key: "catalog_length",
        width: "8%",
        sortable: true,
    },
    {
        title: `Weight`,
        dataIndex: "weight",
        key: "catalog_weight",
        width: "8%",
        sortable: true,
    },
    {
        title: `OD`,
        dataIndex: "od",
        key: "catalog_od",
        width: "8%",
        sortable: true,
    },
    {
        title: `Series`,
        dataIndex: "series",
        key: "catalog_series",
        width: "8%",
        sortable: true,
    },
    {
        title: `Shaft type`,
        dataIndex: "shaftType",
        key: "catalog_shaftType",
        width: "8%",
        sortable: true,
    },
    {
        title: `Standardization`,
        dataIndex: "standardization",
        key: "catalog_standardization",
        width: "8%",
        sortable: true,
    },
];

export const auditLogSrGasSeparators = [
    {
        title: `Gas separator`,
        dataIndex: "pN_Description",
        key: "catalog_pN_Description",
        width: "14%",
        sortable: true,
    },
    {
        title: `Action type`,
        dataIndex: "actionType",
        key: "audit_actionType",
        width: "10%",
        sortable: true,
    },
    {
        title: `Created on`,
        dataIndex: "createdOn",
        key: "audit_createdOn",
        width: "10%",
        sortable: true,
        render: (_: string, record: { audit_createdOn: string }) => (
            <>
                {record?.audit_createdOn && moment(record?.audit_createdOn).format("DD MMM YYYY")}
            </>
        ),
    },
    {
        title: `Created by`,
        dataIndex: "createdByName",
        key: "audit_createdByName",
        width: "10%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "status",
        key: "catalog_status",
        width: "8%",
        sortable: true,
    },
    {
        title: `PN`,
        dataIndex: "pn",
        key: "catalog_pn",
        width: "8%",
        sortable: true,
    },
    {
        title: `Length`,
        dataIndex: "length",
        key: "catalog_length",
        width: "8%",
        sortable: true,
    },
    {
        title: `Weight`,
        dataIndex: "weight",
        key: "catalog_weight",
        width: "8%",
        sortable: true,
    },
    {
        title: `OD`,
        dataIndex: "od",
        key: "catalog_od",
        width: "8%",
        sortable: true,
    },
    {
        title: `Series`,
        dataIndex: "series",
        key: "catalog_series",
        width: "8%",
        sortable: true,
    },
    {
        title: `Series type`,
        dataIndex: "seriesType",
        key: "catalog_seriesType",
        width: "8%",
        sortable: true,
    },
    {
        title: `Position`,
        dataIndex: "position",
        key: "catalog_position",
        width: "8%",
        sortable: true
    },
    {
        title: `Standardization`,
        dataIndex: "standardization",
        key: "catalog_standardization",
        width: "8%",
        sortable: true
    },
];

export const auditLogSrMLE = [
    {
        title: `MLE`,
        dataIndex: "mle",
        key: "catalog_mle",
        width: "15%",
        sortable: true,
    },
    {
        title: `Action type`,
        dataIndex: "actionType",
        key: "audit_actionType",
        width: "10%",
        sortable: true,
    },
    {
        title: `Created on`,
        dataIndex: "createdOn",
        key: "audit_createdOn",
        width: "10%",
        sortable: true,
        render: (_: string, record: { audit_createdOn: string }) => (
            <>
                {record?.audit_createdOn && moment(record?.audit_createdOn).format("DD MMM YYYY")}
            </>
        ),
    },
    {
        title: `Created by`,
        dataIndex: "createdByName",
        key: "audit_createdByName",
        width: "10%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "catalog_equipmentStatus",
        width: "10%",
        sortable: true,
    },
    {
        title: `PN`,
        dataIndex: "mlE_PN",
        key: "catalog_mlE_PN",
        width: "12.5%",
        sortable: true,
    },
    {
        title: `Length`,
        dataIndex: "length",
        key: "catalog_length",
        width: "12.5%",
        sortable: true,
    },
    {
        title: `Weight`,
        dataIndex: "weight",
        key: "catalog_weight",
        width: "12.5%",
        sortable: true,
    },
    {
        title: `Series`,
        dataIndex: "series",
        key: "catalog_series",
        width: "12.5%",
        sortable: true,
    },
    {
        title: `Dimension`,
        dataIndex: "dim__TxW_",
        key: "catalog_dim__TxW_",
        width: "12.5%",
        sortable: true,
    },
    {
        title: `Wire gauge`,
        dataIndex: "wire_Gauge",
        key: "catalog_wire_Gauge",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Standardization`,
        dataIndex: "standardization",
        key: "catalog_standardization",
        width: "12.5%",
        sortable: true,
    },
];

export const auditLogSrMotors = [
    {
        title: `Motor`,
        dataIndex: "name",
        key: "catalog_name",
        width: "7%",
        sortable: true,
    },
    {
        title: `Equipment`,
        dataIndex: "pN_Description",
        key: "catalog_pN_Description",
        width: "9%",
        sortable: true,
    },
    {
        title: `Action type`,
        dataIndex: "actionType",
        key: "audit_actionType",
        width: "7%",
        sortable: true,
    },
    {
        title: `Created on`,
        dataIndex: "createdOn",
        key: "audit_createdOn",
        width: "10%",
        sortable: true,
        render: (_: string, record: { audit_createdOn: string }) => (
            <>
                {record?.audit_createdOn && moment(record?.audit_createdOn).format("DD MMM YYYY")}
            </>
        ),
    },
    {
        title: `Created by`,
        dataIndex: "createdByName",
        key: "audit_createdByName",
        width: "10%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "status",
        key: "catalog_status",
        width: "7%",
        sortable: true,
    },
    {
        title: `PN`,
        dataIndex: "pn",
        key: "catalog_pn",
        width: "7%",
        sortable: true,
    },
    {
        title: `Length`,
        dataIndex: "length",
        key: "catalog_length",
        width: "7%",
        sortable: true,
    },
    {
        title: `Weight`,
        dataIndex: "weight",
        key: "catalog_weight",
        width: "7%",
        sortable: true,
    },
    {
        title: `Series`,
        dataIndex: "series",
        key: "catalog_series",
        width: "7%",
        sortable: true,
    },
    {
        title: `OD`,
        dataIndex: "od",
        key: "catalog_od",
        width: "7%",
        sortable: true,
    },
    {
        title: `Current`,
        dataIndex: "current",
        key: "catalog_current",
        width: "7%",
        sortable: true,
    },
    {
        title: `Voltage`,
        dataIndex: "voltage",
        key: "catalog_voltage",
        width: "7%",
        sortable: true,
    },
    {
        title: `Configuration`,
        dataIndex: "configuration",
        key: "catalog_configuration",
        width: "7%",
        sortable: true,
    },
    {
        title: `Max BHT`,
        dataIndex: "max_BHT",
        key: "catalog_max_BHT",
        width: "7%",
        sortable: true,
    },
    {
        title: `Size`,
        dataIndex: "size",
        key: "catalog_size",
        width: "5%",
        sortable: true,
    },
    {
        title: `Temp unit`,
        dataIndex: "tempUnit",
        key: "catalog_tempUnit",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Base connection`,
        dataIndex: "baseConnection",
        key: "catalog_baseConnection",
        width: "5.5%",
        sortable: true,
    },
    {
        title: `Standardization`,
        dataIndex: "std",
        key: "catalog_std",
        width: "7%",
        sortable: true,
    },
];

export const auditLogSrProtectors = [
    {
        title: `Protector`,
        dataIndex: "name",
        key: "catalog_name",
        width: "7%",
        sortable: true,
    },
    {
        title: `Equipment`,
        dataIndex: "pN_Description",
        key: "catalog_pN_Description",
        width: "9%",
        sortable: true,
    },
    {
        title: `Action type`,
        dataIndex: "actionType",
        key: "audit_actionType",
        width: "8%",
        sortable: true,
    },
    {
        title: `Created on`,
        dataIndex: "createdOn",
        key: "audit_createdOn",
        width: "10%",
        sortable: true,
        render: (_: string, record: { audit_createdOn: string }) => (
            <>
                {record?.audit_createdOn && moment(record?.audit_createdOn).format("DD MMM YYYY")}
            </>
        ),
    },
    {
        title: `Created by`,
        dataIndex: "createdByName",
        key: "audit_createdByName",
        width: "10%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "catalog_equipmentStatus",
        width: "7%",
        sortable: true,
    },
    {
        title: `PN`,
        dataIndex: "pn",
        key: "catalog_pn",
        width: "7%",
        sortable: true,
    },
    {
        title: `Length`,
        dataIndex: "length",
        key: "catalog_length",
        width: "7%",
        sortable: true,
    },
    {
        title: `Weight`,
        dataIndex: "weight",
        key: "catalog_weight",
        width: "7%",
        sortable: true,
    },
    {
        title: `Series`,
        dataIndex: "series",
        key: "catalog_series",
        width: "7%",
        sortable: true,
    },
    {
        title: `OD`,
        dataIndex: "od",
        key: "catalog_od",
        width: "7%",
        sortable: true,
    },
    {
        title: `Shaft material`,
        dataIndex: "shaftMaterial",
        key: "catalog_shaftMaterial",
        width: "7%",
        sortable: true,
    },
    {
        title: `Bearing Type`,
        dataIndex: "bearingType",
        key: "catalog_bearingType",
        width: "7%",
        sortable: true,
    },
    {
        title: `Model`,
        dataIndex: "model",
        key: "catalog_model",
        width: "7%",
        sortable: true,
    },
    {
        title: `Configuration`,
        dataIndex: "configuration",
        key: "catalog_configuration",
        width: "7%",
        sortable: true,
    },
    {
        title: `Standardization`,
        dataIndex: "standardization",
        key: "catalog_standardization",
        width: "7%",
        sortable: true,
    }
];

export const auditLogSrPumps = [
    {
        title: `Pump`,
        dataIndex: "pump",
        key: "catalog_pump",
        width: "8%",
        sortable: true,
    },
    {
        title: `Equipment`,
        dataIndex: "pN_Description",
        key: "catalog_pN_Description",
        width: "12%",
        sortable: true,
    },
    {
        title: `Action type`,
        dataIndex: "actionType",
        key: "audit_actionType",
        width: "8%",
        sortable: true,
    },
    {
        title: `Created on`,
        dataIndex: "createdOn",
        key: "audit_createdOn",
        width: "10%",
        sortable: true,
        render: (_: string, record: { audit_createdOn: string }) => (
            <>
                {record?.audit_createdOn && moment(record?.audit_createdOn).format("DD MMM YYYY")}
            </>
        ),
    },
    {
        title: `Created by`,
        dataIndex: "createdByName",
        key: "audit_createdByName",
        width: "10%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "catalog_equipmentStatus",
        width: "8%",
        sortable: true,
    },
    {
        title: `No of Stages`,
        dataIndex: "noStgs",
        key: "catalog_noStgs",
        width: "8%",
        sortable: true,
    },
    {
        title: `PN`,
        dataIndex: "partNumber",
        key: "catalog_partNumber",
        width: "8%",
        sortable: true,
    },
    {
        title: `Length`,
        dataIndex: "length",
        key: "catalog_length",
        width: "8%",
        sortable: true,
    },
    {
        title: `Weight`,
        dataIndex: "weight",
        key: "catalog_weight",
        width: "8%",
        sortable: true,
    },
    {
        title: `Series`,
        dataIndex: "series",
        key: "catalog_series",
        width: "8%",
        sortable: true,
    },
    {
        title: `OD`,
        dataIndex: "od",
        key: "catalog_od",
        width: "8%",
        sortable: true,
    },
    {
        title: `Shaft type`,
        dataIndex: "shaftType",
        key: "catalog_shaftType",
        width: "8%",
        sortable: true,
    },
    {
        title: `Standardization`,
        dataIndex: "standardization",
        key: "catalog_standardization",
        width: "8%",
        sortable: true,
    },
];

export const auditLogSrSensors = [
    {
        title: `Sensor`,
        dataIndex: "name",
        key: "catalog_name",
        width: "10%",
        sortable: true,
    },
    {
        title: `Action type`,
        dataIndex: "actionType",
        key: "audit_actionType",
        width: "8%",
        sortable: true,
    },
    {
        title: `Created on`,
        dataIndex: "createdOn",
        key: "audit_createdOn",
        width: "10%",
        sortable: true,
        render: (_: string, record: { audit_createdOn: string }) => (
            <>
                {record?.audit_createdOn && moment(record?.audit_createdOn).format("DD MMM YYYY")}
            </>
        ),
    },
    {
        title: `Created by`,
        dataIndex: "createdByName",
        key: "audit_createdByName",
        width: "10%",
        sortable: true,
    },
    {
        title: `Equipment`,
        dataIndex: "pN_Description",
        key: "catalog_pN_Description",
        width: "15%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "status",
        key: "catalog_status",
        width: "10%",
        sortable: true,
    },
    {
        title: `PN`,
        dataIndex: "pn",
        key: "catalog_pn",
        width: "10%",
        sortable: true,
    },
    {
        title: `Length`,
        dataIndex: "length",
        key: "catalog_length",
        width: "10%",
        sortable: true,
    },
    {
        title: `Weight`,
        dataIndex: "weight",
        key: "catalog_weight",
        width: "10%",
        sortable: true,
    },
    {
        title: `Diameter`,
        dataIndex: "diameter",
        key: "catalog_diameter",
        width: "10%",
        sortable: true,
    },
    {
        title: `Standardization`,
        dataIndex: "standardization",
        key: "catalog_standardization",
        width: "10%",
        sortable: true,
    },
];

export const auditLogSrTransformers = [
    {
        title: `Transformer`,
        dataIndex: "transformers",
        key: "catalog_transformers",
        width: "15%",
        sortable: true,
    },
    {
        title: `Action type`,
        dataIndex: "actionType",
        key: "audit_actionType",
        width: "8%",
        sortable: true,
    },
    {
        title: `Created on`,
        dataIndex: "createdOn",
        key: "audit_createdOn",
        width: "10%",
        sortable: true,
        render: (_: string, record: { audit_createdOn: string }) => (
            <>
                {record?.audit_createdOn && moment(record?.audit_createdOn).format("DD MMM YYYY")}
            </>
        ),
    },
    {
        title: `Created by`,
        dataIndex: "createdByName",
        key: "audit_createdByName",
        width: "10%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "equipmentStatus",
        key: "catalog_equipmentStatus",
        width: "10%",
        sortable: true,
    },
    {
        title: `PN`,
        dataIndex: "trnsf__P_N",
        key: "catalog_trnsf__P_N",
        width: "12.5%",
        sortable: true,
    },
    {
        title: `KVA`,
        dataIndex: "kva",
        key: "catalog_kva",
        width: "12.5%",
        sortable: true,
    },
    {
        title: `Sec`,
        dataIndex: "sec",
        key: "catalog_sec",
        width: "12.5%",
        sortable: true,
    },
    {
        title: `Sec Y`,
        dataIndex: "sec_Y",
        key: "catalog_sec_Y",
        width: "12.5%",
        sortable: true,
    },
    {
        title: `Standardization`,
        dataIndex: "standardization",
        key: "catalog_standardization",
        width: "10%",
        sortable: true,
    }
];

export const auditLogSrVSDs = [
    {
        title: `VSD`,
        dataIndex: "aalS_Description",
        key: "catalog_aalS_Description",
        width: "25%",
        sortable: true,
    },
    {
        title: `Action type`,
        dataIndex: "actionType",
        key: "audit_actionType",
        width: "10%",
        sortable: true,
    },
    {
        title: `Created on`,
        dataIndex: "createdOn",
        key: "audit_createdOn",
        width: "10%",
        sortable: true,
        render: (_: string, record: { audit_createdOn: string }) => (
            <>
                {record?.audit_createdOn && moment(record?.audit_createdOn).format("DD MMM YYYY")}
            </>
        ),
    },
    {
        title: `Created by`,
        dataIndex: "createdByName",
        key: "audit_createdByName",
        width: "10%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "status",
        key: "catalog_status",
        width: "10%",
        sortable: true,
    },
    {
        title: `PN`,
        dataIndex: "oracle_Item_Number",
        key: "catalog_oracle_Item_Number",
        width: "10%",
        sortable: true,
    },
    {
        title: `Power`,
        dataIndex: "power",
        key: "catalog_power",
        width: "10%",
        sortable: true,
    },
    {
        title: `UOM`,
        dataIndex: "uom",
        key: "catalog_uom",
        width: "10%",
        sortable: true,
    },
    {
        title: `Standardization`,
        dataIndex: "std",
        key: "catalog_std",
        width: "10%",
        sortable: true,
    },
];


export const auditLogHarmonicFilters = [
    {
        title: `Harmonic Filter`,
        dataIndex: "harmonicFilters",
        key: "catalog_harmonicFilters",
        width: "18%",
        sortable: true,
    },
    {
        title: `Action type`,
        dataIndex: "actionType",
        key: "audit_actionType",
        width: "9%",
        sortable: true,
    },
    {
        title: `Created on`,
        dataIndex: "createdOn",
        key: "audit_createdOn",
        width: "10%",
        sortable: true,
        render: (_: string, record: { audit_createdOn: string }) => (
            <>
                {record?.audit_createdOn && moment(record?.audit_createdOn).format("DD MMM YYYY")}
            </>
        ),
    },
    {
        title: `Created by`,
        dataIndex: "createdByName",
        key: "audit_createdByName",
        width: "10%",
        sortable: true,
    },
    {
        title: `Status`,
        dataIndex: "status",
        key: "catalog_status",
        width: "9%",
        sortable: true,
    },
    {
        title: `PN`,
        dataIndex: "harmPN",
        key: "catalog_harmPN",
        width: "9%",
        sortable: true,
    },
    {
        title: `Filter Type`,
        dataIndex: "filterType",
        key: "catalog_filterType",
        width: "9%",
        sortable: true,
    },
    {
        title: `Amps Filter`,
        dataIndex: "ampsFilter",
        key: "catalog_ampsFilter",
        width: "9%",
        sortable: true,
    },
    {
        title: `Low Limit Amps`,
        dataIndex: "lowLimitAmps",
        key: "catalog_lowLimitAmps",
        width: "9%",
        sortable: true,
    },
    {
        title: `High Limit Amps`,
        dataIndex: "highLimitAmps",
        key: "catalog_highLimitAmps",
        width: "9%",
        sortable: true,
    },
    {
        title: `Standardization`,
        dataIndex: "standardization",
        key: "catalog_standardization",
        width: "9%",
        sortable: true,
    },
];

export const dateRangeOptions = [
    {
        id: 1,
        icon: <Calendar size={20} color="#FCFCFD" />,
        label: "Date range",
        type: "secondary",
        className: "px-[18px] py-2 font-bold whitespace-nowrap",
    },
];

export const exportButtonOptions = [
    {
        id: 1,
        icon: <Download size={20} color="#FCFCFD" />,
        label: "Export",
        type: "secondary",
        className: "px-[18px] py-3 font-bold whitespace-nowrap",
    },
];

export const catalogDropdownOptions = [
    { id: "0", name: "DR cables" },
    { id: "1", name: "DR gas handlers" },
    { id: "2", name: "DR gas separators" },
    { id: "3", name: "DR motor leads" },
    { id: "4", name: "DR motor sensors" },
    { id: "5", name: "DR motors" },
    { id: "6", name: "DR protectors" },
    { id: "7", name: "DR pumps" },
    { id: "8", name: "DR switch board" },
    { id: "9", name: "DR VSD" },
    { id: "10", name: "SR AccAboveESP" },
    { id: "11", name: "SR AccBelowESP" },
    { id: "12", name: "SR BOH" },
    { id: "13", name: "SR cables" },
    { id: "14", name: "SR gas handlers" },
    { id: "15", name: "SR gas separators" },
    { id: "16", name: "SR MLE" },
    { id: "17", name: "SR motors" },
    { id: "18", name: "SR protectors" },
    { id: "19", name: "SR pumps" },
    { id: "20", name: "SR transformers" },
    { id: "21", name: "SR VSDs" },
    { id: "22", name: "Harmonic Filters" }
];